export default {
    "de": {
        "auth": {
            "login": "Login",
            "username": "Benutzername",
            "password": "Passwort",
            "password_confirm": "Passwort wiederholen",
            "disabled": "Dieser Zugang wurde deaktiviert",
            "failed": "Diese Zugansdaten konnten nicht gefunden werden.",
            "throttle": "Zu viele Loginversuche. Bitte probiere es in {seconds} Sekunden erneut.",
            "email_confirm_success": "Die E-Mail-Adresse wurde erfolgreich bestätigt!"
        },
        "general": {
            "add": "hinzufügen",
            "back": "zurück",
            "next": "weiter",
            "search": "suchen",
            "year": "Jahr",
            "month": "Monat",
            "day": "Tag",
            "or": "oder",
            "default": "Voreinstellung",
            "days": {
                "mon": {
                    "short": "Mo",
                    "long": "Montag"
                },
                "tue": {
                    "short": "Di",
                    "long": "Dienstag"
                },
                "wed": {
                    "short": "Mi",
                    "long": "Mittwoch"
                },
                "thu": {
                    "short": "Do",
                    "long": "Donnerstag"
                },
                "fri": {
                    "short": "Fr",
                    "long": "Freitag"
                },
                "sat": {
                    "short": "Sa",
                    "long": "Samstag"
                },
                "sun": {
                    "short": "So",
                    "long": "Sonntag"
                }
            },
            "address": "Adresse",
            "city": "Stadt",
            "zip": "PLZ",
            "country": "Land",
            "email": "E-Mail",
            "homepage": "Homepage",
            "telephone": "Telefon",
            "mobile": "Mobil",
            "company": "Firma",
            "name": "Name",
            "forename": "Vorname",
            "surname": "Nachname",
            "street_nr": "Straße/Nr.",
            "zip_city": "PLZ/Stadt",
            "pob": "Postfach",
            "birthday": "Geburtstag",
            "birthday_invalid": "Bitte ein gültiges Geburtsdatum eingeben",
            "vat": "USt-IdNr (VAT ID)",
            "tin": "Steueridentifikationsnummer (TIN)",
            "in": "Identifikations-Number (IN) / Handelsregisternummer",
            "in_type": "IN-Typ",
            "birth_place": "Geburtsort",
            "former_country_name": "Ehemaliger Name des Landes",
            "financial_identifier": "Finanzkonto",
            "tax_information": "Steuerrechtliche Angaben",
            "open": "Öffnen",
            "save": "Speichern",
            "send": "Senden",
            "discard": "Verwerfen",
            "saved": "Gespeichert",
            "ok": "OK",
            "cancel": "Abbrechen",
            "descending": "absteigend",
            "ascending": "aufsteigend",
            "yes": "Ja",
            "no": "Nein",
            "active": "aktiv",
            "inactive": "inaktiv",
            "loading": "lädt",
            "last_online": "Zuletzt online",
            "never": "Nie",
            "close": "Schließen",
            "optional": "optional",
            "choose_option": "Bitte wähle eine Option aus...",
            "referrer": "Werber-Id",
            "your_email": "Deine Email-Adresse",
            "subject": "Betreff",
            "message": "Nachricht",
            "check_tac": "Ich habe die {link} AGB</a> gelesen und bin mit diesen einverstanden.",
            "check_privacy": "Hiermit willige ich in die Speicherung und Verarbeitung meiner personenbezogenen Daten ein. Die Informationen der {link} Datenschutzerklärung</a> zur Verarbeitung meiner personenbezogenen Daten und zum Datenschutz habe ich zur Kenntnis genommen.",
            "throttled": "Bitte warte, bevor du es erneut versuchst.",
            "server_error": "Es ist ein Fehler aufgetreten. Bitte probiere es später noch einmal.",
            "unkown_error": "Es ist ein Fehler aufgetreten.",
            "form_invalid": "Die Daten konnten nicht gespeichert werden",
            "order_by": {
                "id": "Nach ID sortieren",
                "rating": "Nach Bewertung sortieren",
                "views": "Nach Views sortieren",
                "sales": "Nach Käufen sortieren",
                "title": "Nach Titel sortieren",
                "duration": "Nach Dauer sortieren"
            },
            "german": "deutsch",
            "english": "englisch",
            "status_waiting": "Wird geprüft",
            "status_accepted": "Prüfung erfolgreich",
            "status_rejected": "Wurde abgelehnt",
            "select_all": "Alles auswählen",
            "select_none": "Auswähl aufheben",
            "setting_disabled_by_admin": "Diese Einstellung steht nicht zur Verfügung",
            "settings_locked_by_admin": "Bitte wende dich an den Support, um diese Einstellung zu ändern",
            "setting_disabled_by_master": "Diese Einstellung steht nur dem Master-Account zur Verfügung",
            "errors": {
                "419": "Das Sicherheitstoken ist abgelaufen. Bitte versuche es erneut!",
                "404": "Die gesuchte Seite konnte nicht gefunden werden."
            }
        },
        "macros": {
            "heading": "Makros",
            "greeting": "Begrüßung",
            "greeting_sub": "Wähle aus, welche Nachricht der User erhält, wenn er den Chat betritt.",
            "description": "Wenn du im Chat häufig denselben Text verwendest, kannst du stattdessen Makros verwenden. Während des Chats kannst du deinen Textausschnitt mit der entsprechenden Taste (z.B. F1) einfügen. Du kannst ##username## und ##showname## als Platzhalter verwenden."
        },
        "pagination": {
            "previous": "&laquo; Zurück",
            "next": "Weiter &raquo;"
        },
        "getmore": {
            "p1": "Von jeder Zahlung eines von dir geworbenen Users erhältst du zusätzlich 40% als Werbekostenbonus!",
            "p2": "Sobald sich jemand über dich neu registriert, verdienst du bei jeder Zahlung** - so einfach! Verdiene im besten Fall gleich zwei Mal mit Liveshow + Werbebonus.",
            "p3": "Marketing-Tools, Statistiken und Abrechnungsdaten findest du auf der Seite des Partnerprogramms.",
            "p_register": "Hierfür benötigst du einen Werberaccount (Partneraccount) bei 777partner.com. Klicke dazu einfach auf die folgende Schaltfläche. Die Anmeldung wird automatisch für dich erledigt, natürlich kostenlos und unverbindlich.",
            "getmore_active": "freigeschaltet",
            "getmore_inactive": "Einrichtung ausstehend",
            "payout_title": "GetMore-Umsatz (90 Tage)",
            "user_title": "Userwerbung (90Tage)",
            "user": "Umsatz-User",
            "btn_register": "Partner-Account einrichten",
            "partner_link": "Zum Partnerprogramm",
            "directlink": "Direktlink für die eigene Show",
            "select_show": "Bitte eine Show auswählen",
            "affiliate_link": "Gesamtprogramm bewerben",
            "stats_hint": "Werte können abweichen. Die endgültigen Zahlen siehst du auf der Seite des Partnerprogramms.",
            "terms_hint": "Details zur Werbevergütung kannst du den AGB von 777partner.com entnehmen.",
            "error": "Es ist ein Fehler aufgetreten. Bitte wende dich an den Support, wenn der Fehler bestehen bleibt.",
            "account_error": "Der Partner-Account konnte nicht geladen werden. Bitte wende dich an den Support, wenn der Fehler bestehen bleibt.",
            "partner_toc": "Wirb neue User mit unserem Partnerprogramm und steigere deinen Verdienst mit jeder Zahlung deines geworbenen Users",
            "referrer_toc": "Wirb weitere Master-Accounts und profitiere von dem Umsatz deiner Freunde",
            "partner_title": "Partnerprogramm - Wirb neue User und verdiene mit",
            "referrer_title": "Master-Account werben",
            "referrer_text": "Hast du eine Bekannte, die auch Cam-Girl werden möchte? Benutze diesen Affiliate-Link und erhalte mindestens 50€, wenn der geworbene Master-Account drei Monate in Folge eine Auszahlung erhalten hat. Ein höherer Auszahlungsbetrag ist nach individueller Prüfung möglich!",
            "referrer_hint": "Dies ist ein unverbindliches Angebot, das nur für Master-Accounts gilt, die aktiv eigene Shows auf unseren Plattformen betreiben und regelmäßige Auszahlungen erhalten. Die Shows des geworbenen Master-Accounts dürfen nicht bereits auf unserer Platform senden."
        },
        "validation": {
            "login_characters": "Folgende Zeichen sind für Login nicht erlaubt: {chars}",
            "password_characters": "Folgende Zeichen sind für Passwort nicht erlaubt: {chars}",
            "showname_characters": "Folgende Zeichen sind für Showname nicht erlaubt: {chars}",
            "accepted": "{attribute} muss akzeptiert werden.",
            "active_url": "{attribute} ist keine gültige Internet-Adresse.",
            "after": "{attribute} muss ein Datum nach dem {date} sein.",
            "after_or_equal": "{attribute} muss ein Datum nach dem {date} oder gleich dem {date} sein.",
            "alpha": "{attribute} darf nur aus Buchstaben bestehen.",
            "alpha_dash": "{attribute} darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
            "alpha_num": "{attribute} darf nur aus Buchstaben und Zahlen bestehen.",
            "array": "{attribute} muss ein Array sein.",
            "before": "{attribute} muss ein Datum vor dem {date} sein.",
            "before_or_equal": "{attribute} muss ein Datum vor dem {date} oder gleich dem {date} sein.",
            "between": {
                "numeric": "{attribute} muss zwischen {min} & {max} liegen.",
                "file": "{attribute} muss zwischen {min} & {max} Kilobytes groß sein.",
                "string": "{attribute} muss zwischen {min} & {max} Zeichen lang sein.",
                "array": "{attribute} muss zwischen {min} & {max} Elemente haben."
            },
            "boolean": "{attribute} muss entweder 'true' oder 'false' sein.",
            "confirmed": "{attribute} stimmt nicht mit der Bestätigung überein.",
            "date": "{attribute} muss ein gültiges Datum sein.",
            "date_equals": "{attribute} muss ein Datum gleich {date} sein.",
            "date_format": "{attribute} entspricht nicht dem gültigen Format für {format}.",
            "different": "{attribute} und {other} müssen sich unterscheiden.",
            "digits": "{attribute} muss {digits} Stellen haben.",
            "digits_between": "{attribute} muss zwischen {min} und {max} Stellen haben.",
            "dimensions": "{attribute} hat ungültige Bildabmessungen.",
            "distinct": "{attribute} beinhaltet einen bereits vorhandenen Wert.",
            "email": "{attribute} muss eine gültige E-Mail-Adresse sein.",
            "ends_with": "{attribute} muss eine der folgenden Endungen aufweisen: {values}",
            "exists": "Der gewählte Wert für {attribute} ist ungültig.",
            "file": "{attribute} muss eine Datei sein.",
            "filled": "{attribute} muss ausgefüllt sein.",
            "gt": {
                "numeric": "{attribute} muss größer als {value} sein.",
                "file": "{attribute} muss größer als {value} Kilobytes sein.",
                "string": "{attribute} muss länger als {value} Zeichen sein.",
                "array": "{attribute} muss mehr als {value} Elemente haben."
            },
            "gte": {
                "numeric": "{attribute} muss größer oder gleich {value} sein.",
                "file": "{attribute} muss größer oder gleich {value} Kilobytes sein.",
                "string": "{attribute} muss mindestens {value} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {value} Elemente haben."
            },
            "image": "{attribute} muss ein Bild sein.",
            "in": "Der gewählte Wert für {attribute} ist ungültig.",
            "in_array": "Der gewählte Wert für {attribute} kommt nicht in {other} vor.",
            "integer": "{attribute} muss eine ganze Zahl sein.",
            "ip": "{attribute} muss eine gültige IP-Adresse sein.",
            "ipv4": "{attribute} muss eine gültige IPv4-Adresse sein.",
            "ipv6": "{attribute} muss eine gültige IPv6-Adresse sein.",
            "json": "{attribute} muss ein gültiger JSON-String sein.",
            "lt": {
                "numeric": "{attribute} muss kleiner als {value} sein.",
                "file": "{attribute} muss kleiner als {value} Kilobytes sein.",
                "string": "{attribute} muss kürzer als {value} Zeichen sein.",
                "array": "{attribute} muss weniger als {value} Elemente haben."
            },
            "lte": {
                "numeric": "{attribute} muss kleiner oder gleich {value} sein.",
                "file": "{attribute} muss kleiner oder gleich {value} Kilobytes sein.",
                "string": "{attribute} darf maximal {value} Zeichen lang sein.",
                "array": "{attribute} darf maximal {value} Elemente haben."
            },
            "max": {
                "numeric": "{attribute} darf maximal {max} sein.",
                "file": "{attribute} darf maximal {max} Kilobytes groß sein.",
                "string": "{attribute} darf maximal {max} Zeichen haben.",
                "array": "{attribute} darf maximal {max} Elemente haben."
            },
            "mimes": "{attribute} muss den Dateityp {values} haben.",
            "mimetypes": "{attribute} muss den Dateityp {values} haben.",
            "min": {
                "numeric": "{attribute} muss mindestens {min} sein.",
                "file": "{attribute} muss mindestens {min} Kilobytes groß sein.",
                "string": "{attribute} muss mindestens {min} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {min} Elemente haben."
            },
            "not_in": "Der gewählte Wert für {attribute} ist ungültig.",
            "not_regex": "{attribute} hat ein ungültiges Format.",
            "numeric": "{attribute} muss eine Zahl sein.",
            "password": "Das Passwort ist falsch.",
            "present": "{attribute} muss vorhanden sein.",
            "regex": "{attribute} Format ist ungültig.",
            "required": "{attribute} muss ausgefüllt werden.",
            "required_if": "{attribute} muss ausgefüllt werden, wenn {other} den Wert {value} hat.",
            "required_unless": "{attribute} muss ausgefüllt werden, wenn {other} nicht den Wert {values} hat.",
            "required_with": "{attribute} muss ausgefüllt werden, wenn {values} ausgefüllt wurde.",
            "required_with_all": "{attribute} muss ausgefüllt werden, wenn {values} ausgefüllt wurde.",
            "required_without": "{attribute} muss ausgefüllt werden, wenn {values} nicht ausgefüllt wurde.",
            "required_without_all": "{attribute} muss ausgefüllt werden, wenn keines der Felder {values} ausgefüllt wurde.",
            "same": "{attribute} und {other} müssen übereinstimmen.",
            "size": {
                "numeric": "{attribute} muss gleich {size} sein.",
                "file": "{attribute} muss {size} Kilobyte groß sein.",
                "string": "{attribute} muss {size} Zeichen lang sein.",
                "array": "{attribute} muss genau {size} Elemente haben."
            },
            "starts_with": "{attribute} muss mit einem der folgenden Anfänge aufweisen: {values}",
            "string": "{attribute} muss ein String sein.",
            "timezone": "{attribute} muss eine gültige Zeitzone sein.",
            "unique": "{attribute} ist bereits vergeben.",
            "uploaded": "{attribute} konnte nicht hochgeladen werden.",
            "url": "{attribute} muss eine URL sein.",
            "uuid": "{attribute} muss ein UUID sein.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "languages": {
                    "required": "Bitte mindestens eine Sprache angeben",
                    "min": "Bitte mindestens eine Sprache angeben",
                    "max": "Bitte maxmimal vier Sprachen angeben"
                },
                "erotic_interests": {
                    "required": "Bitte mindestens ein erotisches Interesse angeben",
                    "min": "Bitte mindestens ein erotisches Interesse angeben",
                    "max": "Bitte maxmimal fünf erotische Interessen angeben"
                },
                "character_features": {
                    "required": "Bitte mindestens eine Charakter-Eigenschaft angeben",
                    "min": "Bitte mindestens eine Charakter-Eigenschaft angeben",
                    "max": "Bitte maxmimal zehn Charakter-Eigenschaften angeben"
                },
                "bust_size_number": {
                    "min": "Bitte eine realistische Oberweite angeben"
                },
                "city": {
                    "min": "Bitte eine Stadt auswählen"
                },
                "country": {
                    "min": "Bitte ein Land auswählen"
                },
                "orientation": {
                    "min": "Bitte eine Ausrichtung auswählen"
                },
                "gender": {
                    "min": "Bitte ein Geschlecht auswählen"
                },
                "reportable_seller.addresses.*.city": {
                    "required": "Zur Adresse muss eine Stadt angegeben werden"
                },
                "reportable_seller.addresses.*.country_code": {
                    "required": "Zur Adresse muss ein Land angegeben werden"
                },
                "reportable_seller.seller_type": {
                    "required": "Bitte wähle eine Steuerklassifizierung"
                },
                "reportable_seller.financial_identifiers.*.identifier": {
                    "required": "Finanzkonto muss angegeben werden"
                },
                "reportable_seller.financial_identifiers.*.account_number_type": {
                    "required": "Finanzkonto-Typ muss angegeben werden"
                },
                "reportable_seller.financial_identifiers.*.account_holder_name": {
                    "required_if": "Kontoinhaber muss angegeben werden"
                },
                "reportable_seller.financial_identifiers.*.other_info": {
                    "required_if": "Informationen zum abweichenden Kontoinhaber muss angegeben werden"
                },
                "reportable_seller.financial_identifiers.*.other_info_address": {
                    "required_if": "Adresse des abweichenden Kontoinhabers muss angegeben werden"
                },
                "reportable_seller.first_name": {
                    "required_if": "Vorname muss angegeben werden"
                },
                "reportable_seller.last_name": {
                    "required_if": "Nachname muss angegeben werden"
                },
                "reportable_seller.birth_date": {
                    "required_if": "Geburtstag muss angegeben werden"
                },
                "reportable_seller.company_name": {
                    "required_if": "Firma muss angegeben werden"
                },
                "reportable_seller.tins.*.tin": {
                    "required_if": "Steueridentifikationsnummer (TIN) muss angegeben werden"
                },
                "reportable_seller.ins.*.in": {
                    "required_if": "Identifikations-Number (IN) muss angegeben werden"
                },
                "reportable_seller.ins.*.issued_by": {
                    "required_if": "Zur Identifikations-Number (IN) muss ein Land angegeben werden"
                },
                "reportable_seller.financial_identifiers.*.other_info_tin_country": {
                    "required_with": "Zur Steueridentifikationsnummer (TIN) muss ein Land angegeben werden"
                },
                "reportable_seller.tins.*.issued_by": {
                    "required_with": "Zur Steueridentifikationsnummer (TIN) muss ein Land angegeben werden"
                },
                "reportable_seller.tins.0.issued_by": {
                    "in": "Land (TIN) muss mit dem Land der Adresse übereinstimmen"
                }
            },
            "attributes": {
                "file": "Datei",
                "doctype": "Typ",
                "name": "Name",
                "username": "Benutzername",
                "email": "E-Mail Adresse",
                "first_name": "Vorname",
                "last_name": "Nachname",
                "password": "Passwort",
                "password_confirmation": "Passwort Bestätigung",
                "city": "Stadt",
                "country": "Land",
                "address": "Adresse",
                "phone": "Telefonnummer",
                "mobile": "Handynummer",
                "age": "Alter",
                "sex": "Geschlecht",
                "gender": "Geschlecht",
                "day": "Tag",
                "month": "Monat",
                "year": "Jahr",
                "hour": "Stunde",
                "minute": "Minute",
                "second": "Sekunde",
                "title": "Titel",
                "content": "Inhalt",
                "description": "Beschreibung",
                "excerpt": "Auszug",
                "date": "Datum",
                "time": "Uhrzeit",
                "available": "verfügbar",
                "size": "Größe",
                "cam_admin.provision": "Umsatzanteil",
                "priceperminuteid": "Endkundenpreis",
                "price": "Endkundenpreis",
                "password_confirm": "Passwort wiederholen",
                "contact.email": "E-Mail",
                "contact.vorname": "Vorname",
                "contact.nachname": "Nachname",
                "contact.strasse": "Straße",
                "contact.plz": "PLZ",
                "contact.stadt": "Stadt",
                "contact.nationID": "Land",
                "contact.telefon": "Telefon",
                "contact.handy": "Mobil",
                "contact.homepage": "Homepage",
                "contact.firma": "Firma",
                "contact.birthday": "Geburtstag",
                "contact.company_reg_number": "Handelsreg.-Nr.",
                "paxum_account.email": "Account",
                "paxum_account.email_confirm": "Account bestätigen",
                "paxum_account.type": "Paxum Account-Typ",
                "bank_account.kontoBesitzer": "Kontoinhaber",
                "bank_account.blz": "BLZ",
                "bank_account.bankName": "Bankname",
                "bank_account.kontoNr": "Kontonummer",
                "bank_account.iban": "IBAN",
                "bank_account.bic": "BIC",
                "bank_account.swift": "SWIFT/BIC",
                "bank_account.banksitzID": "Bankland",
                "bank_account.reference": "Referenz",
                "slogan": "Slogan",
                "hobbies": "Hobbies",
                "slogan_de": "Slogan (DE)",
                "slogan_en": "Slogan (EN)",
                "description_de": "Beschreibung (DE)",
                "description_en": "Beschreibung (EN)",
                "hobby": "Hobbies",
                "hobby_de": "Hobbies (DE)",
                "hobby_en": "Hobbies (EN)",
                "hobbies_de": "Hobbies (DE)",
                "hobbies_en": "Hobbies (EN)",
                "bust_size": "Körbchengröße/Oberweite",
                "breastscale": "Oberweite",
                "hair_color": "Haarfarbe",
                "hair_length": "Haare",
                "eye_color": "Augenfarbe",
                "shaving": "Rasur",
                "skin_color": "Hautfarbe",
                "body": "Figur",
                "height": "Größe",
                "piercing": "Piercing",
                "orientation": "Ausrichtung",
                "languages": "Sprachen",
                "beschreibung": "Beschreibung",
                "kurztext": "Titel",
                "beschreibung_eng": "Beschreibung (en)",
                "kurztext_eng": "Titel (en)",
                "beschreibung_fsk18": "Beschreibung (de - hard)",
                "kurztext_fsk18": "Titel (de - hard)",
                "translations.de.description": "Beschreibung (DE)",
                "translations.de.title": "Titel (DE)",
                "translations.en.description": "Beschreibung (EN)",
                "translations.en.title": "Titel (EN)",
                "reportable_seller.birth_city": "Geburtsort (Stadt)",
                "reportable_seller.birth_country_code": "Geburtsort (Land)",
                "reportable_seller.birth_former_country_name": "Geburtsort (Ehemaliger Name des Landes)"
            }
        },
        "phoneservice": {
            "errors": {
                "pin_invalid": "Der eingegebene Code ist ungültig",
                "service_error": "Die Einrichtung des Dienstes ist fehlgeschlagen. Bitte wende dich an den Support, falls dieser Fehler bestehen bleibt.",
                "service_error2": "Der Rückruf konnte nicht gestartet werden. Bitte wende dich an den Support, falls dieser Fehler bestehen bleibt."
            },
            "status": {
                "registered": "Registriert",
                "paused": "Pausiert",
                "active": "Aktiviert",
                "not_registered": "Nicht registriert",
                "busy": "Beschäftigt",
                "not_available": "Nicht verfügbar"
            }
        },
        "imprint": {
            "header": "Impressum",
            "support": "Support",
            "youth": "Jugendschutzbeauftragter",
            "operator": "Betreiber",
            "content": "Datenschutz"
        },
        "public": {
            "legacy_login": {
                "h": "Wir sind umgezogen!",
                "p1": "Klicke auf den Login-Button",
                "p2": "oder rufe folgende Adresse in deinem Browser auf:",
                "login": "Login",
                "help1": "Das Senden per Webcam sowie das Verwalten deines Accounts erledigst du von jetzt an bequem über deinen Browser.",
                "help2": "Du kannst die Software \"777 ShowSoft\" nun schließen und deinstallieren."
            },
            "nav": {
                "home": "Home",
                "start": "Start",
                "register": "Als Amateur oder Agentur registrieren",
                "admin_area": "Verwaltungsbereich",
                "logout": "Logout",
                "sign_up": "Jetzt Anmelden",
                "additional_questions": "Weitere Fragen?",
                "first_steps": "Erste Schritte / Wie geht es weiter?"
            },
            "register": {
                "header": "Jetzt neu als Darsteller oder Agentur anmelden",
                "submit": "Anmeldung absenden",
                "success": "Die Registrierung war erfolgreich! Du erhältst in Kürze eine E-Mail zur Bestätigung."
            },
            "register_done": {
                "header": "Vielen Dank!",
                "p1": "Zur Bestätigung der Registrierung haben wir eine E-Mail an die Adresse <b>{email}</b> gesendet.",
                "p2": "Bitte folge den Anweisungen in der E-Mail, um die Registrierung abzuschließen.",
                "email_confirmation": "E-Mail wiederholen",
                "resend": "Keine E-Mail erhalten?",
                "resend_submit": "E-Mail erneut versenden",
                "resend_success": "Die Bestätigungs-E-Mail wurde erneut versendet!",
                "change": "Vertippt? Neue E-Mail-Adresse eingeben:",
                "change_submit": "Speichern und Bestätigungs-E-Mail erneut senden",
                "change_success": "Die Bestätigungs-E-Mail wurde an die neue E-Mail-Adresse versendet!",
                "hint": "Füge <b>{email}</b> als Kontakt in deinem Adressbuch hinzu, um die Einstufung unserer E-Mail als Spam zu verhindern."
            },
            "side_h1": "Zugangsdaten vergessen?",
            "side_pw_reset_link": "Zugangsdaten anfordern",
            "side_h2": "Support",
            "side_p2": "Unser Support ist immer erreichbar, wir versuchen so schnell und einfach wie möglich zu helfen.",
            "side_support_link": "Support kontaktieren",
            "side_h3": "Show & Sender BLOG",
            "side_p3": "News, umfangreiche Informationen und Beschreibungen zum erfolgreichen Betreiben einer Amateurshow bei 777, findest Du hier."
        },
        "passwords": {
            "password": "Passwörter müssen mindestens 8 Zeichen lang sein und korrekt bestätigt werden.",
            "reset": "Das Passwort wurde zurückgesetzt!",
            "sent": "Wenn der angegebene Benutzername gültig ist, haben wir einen Link zum Zurücksetzen des Passworts an die entsprechende E-Mail-Adresse gesendet!",
            "throttled": "Bitte warte, bevor du es erneut versuchst.",
            "token": "Der Passwort-Wiederherstellungs-Schlüssel ist ungültig oder abgelaufen.",
            "user": "Es konnte leider kein Nutzer mit dieser E-Mail-Adresse gefunden werden.",
            "send_button": "Link zum Zurücksetzen des Passworts senden",
            "reset_button": "Neues Passwort speichern",
            "error": "Es ist ein Fehler aufgetreten. Bitte probiere es später erneut.",
            "reset_master": "Master-Passwort zurücksetzen",
            "reset_show": "Show-Passwort zurücksetzen",
            "reset_link": "Passwort vergessen?",
            "register_link": "Noch keinen Zugang?",
            "login_link": "Login"
        },
        "media": {
            "duration": "Dauer",
            "price": "Preis",
            "sales": "Käufe",
            "rating": "Bewertung",
            "pictures": "Bilder",
            "resolution": "Auflösung",
            "views": "Views",
            "preview_gallery": "Vorschaubilder",
            "preview_gallery_header": "Vorschaubilder - kein Hardcore!",
            "preview_gallery_descr1": "Du benötigst 3 Vorschaubilder in <b>sehr guter Qualität</b> mit einer <b>Mindest-Bildgröße von {width}x{height} Pixel (Querformat)</b>.",
            "preview_gallery_descr2": "Für deinen Erfolg sollten die Bilder \"werbewirksam\" sein und Lust auf mehr machen, sie werden auf Sedcards und Werbetools verwendet.",
            "preview_gallery_descr3": "Verwende <b>aktuelle Bilder</b>, die nicht älter als 1 Jahr sind.",
            "id_cards": "Ausweis",
            "id_cards_header": "Ausweisbilder - Altersnachweis",
            "id_cards_descr1": "Zur Prüfung der Identität und des Alters benötigen wir zwingend einen gut lesbaren Scan bzw. Foto der Vorder- und Rückseite Ihres Personalausweises oder Reisepasses.",
            "id_cards_descr1_video": "Zur Prüfung der Identität und des Alters ALLER Darsteller benötigen wir zwingend einen gut lesbaren Scan bzw. Foto der Vorder- und Rückseite Ihres Personalausweises oder Reisepasses.",
            "id_cards_descr2": "Zusätzlich ist ein \"Schnappschuss\", wo der übermittelte Ausweis rechts neben dem Gesicht gut lesbar und möglichst nah gezeigt wird, erforderlich.",
            "id_cards_descr3": "Bitte wähle die Ausweise ALLER im Video zu sehenden Darsteller an.",
            "documents": "Dokumente",
            "documents_header": "Dokumente",
            "documents_upload": "Hochladen",
            "documents_uploads": "Hochgeladene Dateien",
            "documents_uploads_empty": "Noch keine Uploads vorhanden",
            "document_overview_header": "Dokumentübersicht",
            "documents_shows_home_alert": "Es sind Dokumente erforderlich, um dein Profil zu vervollständigen!",
            "documents_shows_home_link": "Dokumente Verwalten",
            "document_tooltip_required": "Upload benötigt",
            "document_template_link": "Formular",
            "document_title_release": "Freigabe - Erklärung zu Urheberrechten",
            "document_description_release": "Mit diesem Formular versicherst du, dass du keine Rechte Dritter verletzt.\n                                    Außerdem erklärst du, dass du sämtliche Inhalte eigenverantwortlich\n                                    und in eigenem Willen bereitstellst. Du räumst des Weiteren ein, dass\n                                    wir deine Inhalte veröffentlichen dürfen.",
            "document_description_ol1": "Bitte lade das Formular hier herunter",
            "document_description_ol2": "Fülle das ausgedruckte Formular aus und unterschreibe es",
            "document_description_ol3": "Scanne das ausgefüllte Formular ein oder fotografiere es ab, bevor du es hochlädst (.pdf, .jpg, .png)",
            "document_tip_1": "Tipp",
            "document_tip_2": "Formular ohne Drucker ausfüllen und Unterschreiben",
            "free_gallery": "Gratisgalerie",
            "free_gallery_header": "Gratisgalerie - Hardcore erlaubt!",
            "free_gallery_descr1": "Mindestbildgrösse: {width}x{height} Pixel wird vorausgesetzt!",
            "free_gallery_descr2": "Wenn die Galerie vollständig ist, musst du zuerst ein Bild löschen, um ein neues hochladen zu können. Es können auch weitere, kostenpflichtige Galerien angelegt werden.",
            "free_gallery_descr3": "Hier keine Duplikate der Vorschaubilder!",
            "pay_galleries": "Pay-Galerien",
            "contests": "Wettbewerbe",
            "preview_video": "Vorschauvideo",
            "preview_video_header": "Vorschauvideo - kein Hardcore!",
            "pay_videos": "Pay-Videos",
            "pay_videos_header": "Pay-Video - Hardcore erlaubt!",
            "confirm_remove": "Bild wirklich löschen? Das kann man nicht rückgängig machen!",
            "confirm_remove_list": "Ausgewählte Bilder wirklich löschen? Das kann man nicht rückgängig machen!",
            "confirm_delete_gallery": "Galerie mit allen Bildern wirklich löschen? Das kann man nicht rückgängig machen!",
            "confirm_delete_gallery_ok": "Ja, Galerie löschen!",
            "confirm_delete_video": "Das Video wirklich löschen? Das kann man nicht rückgängig machen!",
            "confirm_delete_video_ok": "Ja, Video löschen!",
            "confirm_delete_document": "Dieses Dokument löschen? Je nach Dokumenttyp kannst du möglicherweise erst online gehen, wenn du ein neues Dokument dieses Typs hochgeladen hast.",
            "confirm_delete_document_master": "Dieses Dokument löschen? Je nach Dokumenttyp erhälst du möglicherweise keine Auszahlungen mehr, bis du ein neues Dokument dieses Typs hochgeladen hast.",
            "confirm_delete_document_dac7": "Dieses Dokument löschen? Du musst das DAC7-Steuerinterview erneut abschließen. Bis dahin sind keine Auszahlungen möglich.",
            "confirm_discard": "Änderungen verwerfen?",
            "confirm_discard_ok": "Änderungen verwerfen!",
            "confirm_cancel": "Abbrechen",
            "edit_upload_hint": "Neues Bild bearbeiten und hochladen",
            "drag_hint": "Dateien hereinziehen oder hier klicken, um hochzuladen!",
            "drag_hint2": "Dateien hereinziehen oder hier klicken, um Datei auszuwählen!",
            "max_images_reached": "Maximum erreicht",
            "min_image_size": "Bild ist zu klein",
            "min_image_size_with_hint": "Bild ist zu klein {hint}",
            "wrong_preview_aspect_hint": "Vorschaubilder müssen im Querformat hochgeladen werden",
            "file_not_supported": "Datei-Typ nicht unterstützt",
            "duplicate": "Bild wurde bereits hochgeladen",
            "create_gallery": "Neue Galerie",
            "create_video": "Neues Video",
            "create_video_hint": "Bitte gib einen Titel und eine Beschreibung ein und klicke auf Speichern. Anschließend kann eine Videodatei hochgeladen werden.",
            "create_video_no_preview": "Freigeschaltetes Vorschauvideo benötigt",
            "edit_video": "Video bearbeiten",
            "edit_gallery": "Galerie bearbeiten",
            "create_in_process": "Bitte zuerst diese Galerie zur Überprüfung freigeben",
            "gallery_sold_hint": "Galerie wurde bereits verkauft. Freigeschaltete Bilder können nicht gelöscht werden.",
            "gallery_sort_up": "Neue Bilder nach hinten sortieren",
            "gallery_sort_down": "Neue Bilder nach vorne sortieren",
            "gallery_sort_confirm": "Aktuelle Sortierung verwerfen?",
            "gallery_sort_hint": "Sortiere die Bilder per Drag and Drop (<i class=\"fas fa-grip-horizontal\"></i>) oder nach Upload-Reihenfolge (<i class=\"fas fa-sort-up\"></i> <i class=\"fas fa-sort-down\"></i>).",
            "form": {
                "title": "Titel",
                "description": "Beschreibung",
                "tags": "Tags",
                "price": "Endkundenpreis pro Bild",
                "gallerytype": "Jugendschutz",
                "finish_gallery": "Galerie zur Überprüfung freigeben",
                "finish_gallery_tip": "Bitte mindestens 5 Bilder hochladen",
                "review_in_progress": "Galerie wird überprüft"
            },
            "document_form": {
                "select": "Datei auswählen...",
                "upload": "Jetzt hochladen",
                "already_uploaded": "bereits hochgeladen",
                "doctype_release": "Freigabeformular",
                "doctype_financial_account": "Erklärung zum Finanzkontoinhaber / Freistellungserklärung",
                "doctype_other": "Sonstiges",
                "doctype_placeholder": "Welches Dokument soll hochgeladen werden?"
            },
            "video_form": {
                "description_soft": "Hier die 'Soft-Beschreibung' (kein Hardcore) zu diesem Video eingeben.",
                "title_soft": "Hier den 'Soft-Titel' (kein Hardcore) zu diesem Video eingeben.",
                "title_hard": "Hier den Titel für das Video eintragen. Darf und sollte Hardcore sein!",
                "description_hard": "Hier die Beschreibung zu diesem Video eingeben. Darf und sollte Hardcore sein!",
                "price": "Endkundenpreis pro Minute",
                "confirm_save_reset_status": "Das Video wird überprüft und wird währenddessen nicht auf der Webseite angezeigt.",
                "video_status_2": "Das Video wird verarbeitet. Sobald die Verarbeitung abgeschlossen ist, wird es überprüft.",
                "video_status_3": "Das Video wurde verarbeitet! Es wird so schnell wie möglich überprüft.",
                "confirm_upload": "Videodatei {file} jetzt hochladen?",
                "other_actors": "Es sind noch andere Personen außer mir in dem Video zu sehen"
            },
            "video_upload": {
                "start": "Jetzt Hochladen",
                "max_file_size": "Maximale Dateigröße 5000 MB",
                "preview_duration": "Mindestdauer 30 Sekunden, nur die ersten 40 Sekunden werden verwendet",
                "pay_duration": "Mindestdauer 60 Sekunden",
                "min_dimensions": "Mindestens 640x480 Pixel Auflösung in guter Qualität"
            },
            "video_thumbnail": {
                "upload_thumbnail": "Thumbnail hochladen",
                "take_snapshot": "Schnappschuss machen",
                "move_right": "nach rechts verschieben",
                "move_left": "nach links verschieben",
                "save": "Schnappschuss speichern",
                "abort": "Abbrechen",
                "invalid_proportions": "Ungültiges Format. Bitte lade ein Bild im Querformat hoch.",
                "invalid_height": "Bitte lade ein Bild mit mindestens {widthx}{height} Pixel Auflösung hoch.",
                "invalid_width": "Bitte lade ein Bild mit mindestens {widthx}{height} Pixel Auflösung hoch."
            },
            "errors": {
                "upload_error": "Upload fehlgeschlagen. Bitte versuche es erneut.",
                "delete_image_agechecked": "Das Ausweisbild kann nicht entfernt werden. Bitte melde dich beim Support.",
                "delete_image_gallery_sold": "Das Bild konnte nicht gelöscht werden: Galerie wurde bereits gekauft.",
                "video_min_duration": "Das Video ist zu kurz!",
                "video_min_resolution": "Die Auflösung des Videos ist zu klein!"
            }
        },
        "notes": {
            "dialog_title": "Notizen",
            "placeholder": "Gib einen Namen und weitere Notizen ein",
            "tooltip": "Notizen"
        },
        "invoice": {
            "transaction": "Auszahlung",
            "invoice": "Rechnung",
            "paxum_id": "Paxum-ID",
            "accound_holder": "Kontoinhaber",
            "bank": "Bank",
            "bank_id": "BIC",
            "bank_account_id": "IBAN",
            "balance": "Saldo"
        },
        "contact": {
            "header": "Kontakt",
            "success": "Die Nachricht wurde gesendet!"
        },
        "editor": {
            "crop": "Auf Auswahl zuschneiden",
            "crop_short": "Zuschneiden",
            "left": "Nach links drehen",
            "left_short": "Links drehen",
            "right": "Nach rechts drehen",
            "right_short": "Rechts drehen",
            "rotate": "Drehen",
            "center": "Bild zentrieren",
            "center_short": "Zentrieren",
            "reset": "Bild zurücksetzen",
            "reset_short": "Zurücksetzen",
            "save": "Speichern und hochladen",
            "save_short": "Speichern",
            "close": "Verwerfen und schließen",
            "close_short": "Verwerfen",
            "no_support": "Dieser Browser wird nicht unterstützt. Bitte verwende einen aktuellen Browser."
        },
        "lovense": {
            "app": {
                "title": "Dienst-Status",
                "pending": "Pending",
                "instructions1": "Um die Toy-Steuerung in deinem Chat verwenden zu können, musst du den Dienst hier einmaldig einrichten:",
                "setup_now": "Dienst jetzt einrichten",
                "setup_pending": "Der Dienst wird in Kürze vom Support freigeschaltet.",
                "setup_rejected": "Der Dienst kann leider nicht verwendet werden.",
                "setup_active": "Der Dienst wurde erfolgreich eingerichtet und ist aktiv!",
                "setup_paused": "Der Dienst ist momentan inaktiv.",
                "status_not_set_up": "Nicht eingerichtet",
                "status_not_available": "Nicht verfügbar",
                "download": "Lade die <b><a target=\"_blank\" href=\"https://lovense.com/cam-model/extension\">Lovense Connect App</a></b> für Computer oder Smartphone herunter",
                "start": "Starte die App und Verbinde dein <a target=\"_blank\" href=\"https://lovense.com/public/store\">Toy</a>",
                "start2": "Für Windows wird zusätzlich der <a target=\"_blank\" href=\"https://lovense.com/bluetooth-adapter\">USB-Adapter</a> benötigt",
                "start3": "Achte stets darauf, dass dein <b>Toy aufgeladen</b> ist",
                "go_online": "Gehe online und klicke auf den <button disabled class=\"btn btn-sm btn-primary\"><i class=\"fa fa-lush\"></i> LOVENSE</button> Button",
                "go_online2": "Scanne den QR-Code, wenn du die Smartphone-App verwendest",
                "done": "Deine User können dein Toy aktivieren, indem sie dir ein Trinkgeld senden"
            },
            "level": {
                "title": "Trinkgeld-Stufen",
                "level": "Level",
                "coins": "Coins",
                "duration": "Dauer",
                "vibration": "Vibration",
                "seconds": "{seconds} Sekunden",
                "low": "niedrig",
                "medium": "mittel",
                "high": "hoch"
            },
            "auto_disable": {
                "days": "Zeit bis zur Deaktivierung: {days} Tage",
                "shortly": "Der Dienst wird in Kürze deaktiviert.",
                "info": "Der Dienst wird nach längerer Inaktivität automatisch deaktiviert. Du kannst den Dienst jederzeit wieder reaktivieren."
            }
        },
        "master": {
            "base_data": "Stammdaten",
            "personal_data": "Persönliche Daten",
            "clearing_options": "Abrechnung",
            "tax": "Steuer",
            "confirmation_email_sent": "Es wurde eine E-Mail an {email} geschickt. Bitte klicke auf den Link in der E-Mail, um deine neue E-Mail-Adresse zu bestätigen.",
            "blocked_while_dac7_waiting": "Daten können nicht geändert werden, während das DAC7-Steuerinterview geprüft wird.",
            "conditions": {
                "header": "Masterkonditionen",
                "th1": "Endkundentarif",
                "th2": "Masterprovision"
            },
            "home": {
                "header": "Masterzugang / Hauptverwaltung",
                "newsletter": "Unsere letzten 5 Newsletter",
                "todos": "To-do",
                "todos_done": "Nichts zu tun",
                "todo_idcard": "Ausweis fehlt/noch nicht überprüft",
                "todo_documents": "Dokumente fehlen",
                "todo_profile": "Profil unvollständig oder wartet auf Bestätigung vom Support",
                "todo_preview": "Vorschaubilder fehlen/noch nicht überprüft",
                "todo_free": "Free-Galerie-Bilder fehlen/noch nicht überprüft",
                "todo_price": "Es müssen Preise eingestellt werden",
                "todo_pics": "Es fehlen Bilder in Galerien",
                "todos_paxum_title": "Paxum-Account vervollständigen",
                "todos_paxum_link": "Paxum-Account",
                "show_listheader": "Shows",
                "showlist_online": "Jetzt online",
                "showlist_offline": "Offline",
                "showlist_disabled": "Deaktiviert",
                "showlist_disabled_check": "Deaktivierte Shows anzeigen",
                "tac": "AGB",
                "support_messages": "Support-Nachrichten",
                "support_messages_master": "Support an Master",
                "support_messages_shows": "Support an Show",
                "user_messages": "User-Nachrichten",
                "conversations": "Nachrichten an Shows",
                "premium_messages": "Premium-Nachrichten",
                "todo_no_show": "Erstelle jetzt eine Show, um loszulegen!",
                "locked": "Sie sind gesperrt. Bitte wenden Sie sich an den Support."
            },
            "clearing": {
                "show_id": "Show-ID auf Abrechnung",
                "show_name": "Showname auf Abrechnung",
                "factoring": "Auszahlung",
                "factoring_0": "Mitte des Monats",
                "factoring_1": "Anfang des Monats (-2%)",
                "payout_type": "Auszahlung durch",
                "payout_type_0": "Keine Auszahlung",
                "payout_type_1": "Bank Überweisung",
                "payout_type_3": "Paxum",
                "payout_limit": "Auszahlung ab",
                "clearing_annotation": "Anmerkung auf Abrechnung",
                "clearing_annotation_hint": "(Optional - z.B. für Buchhaltung)",
                "fees": "Auszahlungsgebühren",
                "fees_bank": "Banküberweisung (weltweit): 0,00 EUR",
                "fees_bank_sub": "Außerhalb SEPA-Raum: es können weitere Gebühren durch die Banken anfallen",
                "fees_paxum": "Paxum: nur 0,99 EUR",
                "fees_paxum_sub": "Es können weitere Gebühren durch den Anbieter anfallen",
                "paxum_type": "Account-Typ",
                "paxum_type_choose": "bitte wählen...",
                "paxum_type_personal": "Persönlicher Account",
                "paxum_type_business": "Firmen-Account",
                "paxum_data_hint": "Für Auszahlungen über Paxum werden folgende Daten an Paxum Bank Limited übermittelt.\n                                Bitte trage die Daten in deinem Profil ein:"
            },
            "contact": {
                "email": "E-Mail",
                "vorname": "Vorname",
                "nachname": "Nachname",
                "birthday": "Geburtstag",
                "strasse": "Straße",
                "plz": "PLZ",
                "stadt": "Stadt",
                "nationID": "Land",
                "telefon": "Telefon",
                "handy": "Mobil",
                "homepage": "Homepage",
                "firma": "Firma",
                "vat_id": "USt-IdNr (VAT ID)",
                "company_reg_number": "Handelsreg.-Nr. (HR/BRN)",
                "hint1": "Bitte achte auf die korrekte Angabe <b>aller Daten</b> und gib immer deinen <b>Hauptwohnsitz</b> an. \n                            Ansonsten ist eine Provisionsauszahlung leider nicht möglich. \n                            Unabhängig davon, kann in jedem Showprofil ein anderer Ort angegeben werden. \n                            Es wird nur der Ort des Showprofils für User veröffentlicht!",
                "hint_*": "* Optional - Teile uns mit, wie wir dich erreichen können",
                "hint_**": "** Optional - Benötigt für manche Auszahlungsarten (z.B. Paxum)"
            },
            "account": {
                "identifier": "Finanzkonto",
                "account_type": "Finanzkonto-Typ",
                "bank": "Bank",
                "bank_country": "Bankland",
                "bank_name": "Bankname",
                "account_holder": "Kontoinhaber",
                "account_holder_info": "Informationen zum abweichenden Kontoinhaber",
                "swift": "SWIFT/BIC",
                "account_number": "Kontonummer",
                "reference": "Referenz",
                "bank_street": "Bankstraße/-Nr.",
                "bank_zip": "Bank-Postleitzahl/-Stadt",
                "account": "Account",
                "account_confirm": "Account bestätigen",
                "paxum_confirm": "Ich bestätige, dass ich Auszahlungen auf das oben angegebene Paxum-Konto erhalten möchte.",
                "exemption": "Abweichender Kontoinhaber? Auszahlung erst nach Zusendung der Freistellungserklärung:"
            },
            "master_settings": {
                "title": "Master-Einstellungen",
                "active_title": "Show-Status",
                "active": "Status",
                "chat_title": "Chat",
                "messages_title": "Nachrichten",
                "finances_title": "Finanzen",
                "permissions_title": "Berechtigungen",
                "end_user_price": "Endkundenpreis",
                "price_per_minute": "{price} / Minute",
                "price_per_message": "{price} / Nachricht",
                "price_per_message_hint1": "Neukunden erhalten eine begrenzte Anzahl an Gratisnachrichten. Diese werden nicht vergütet.",
                "price_per_message_hint2": "Kunden haben jedoch die Möglichkeit selbst einen höheren Preis zu wählen (\"Trinkgeld\").",
                "edit_welcome_messages": "Darf die Show Willkommen-Nachrichten bearbeiten?",
                "showlivepic": "Aktuelles Livebild als Vorschaubild zulassen?",
                "sendsound": "Mit Ton senden?",
                "exclusivec2c": "Nur eine Cam2Cam-Sitzung auf einmal?",
                "edit_freemode": "Kann Freechat aktivieren?",
                "edit_exclusivemode": "Kann Exklusiv-Chat-Modes einstellen?",
                "exclusive_voyeur": "Voyeure im Exklusiv-Chat erlaubt?",
                "minpreis": "Kann Preise einstellen (Chat, Bilder, Videos)?",
                "provisionsanzeige": "Darf die Show ihren Umsatzanteil sehen?",
                "umsatzzahlen": "Darf die Show den Master-Umsatz sehen?",
                "provision": "Umsatzanteil der Show in Prozent in Bezug auf deinen Umsatzanteil (= 100%):",
                "edit_setcard": "Showprofil bearbeiten",
                "edit_bilder": "Bilder/Videos bearbeiten",
                "edit_webcam": "Setup (Webcam) ändern",
                "edit_textmakro": "Textmakros bearbeiten",
                "call_active": "Telefon Dienst",
                "view_supportmails": "Supportmails"
            },
            "create_show": {
                "header": "Neue Show",
                "success": "Show erfolgreich erstellt!",
                "success_p1": "Wir haben eine E-Mail mit Login-Informationen an die angegebene E-Mail-Adresse geschickt.",
                "success_p2": "Bitte vervollständige nun das Profil der neuen Show.",
                "show_template": "Vorlage",
                "select_show_template": "Eine vorhandene Show als Vorlage verwenden:",
                "success_edit_show": "Show jetzt bearbeiten"
            },
            "shows": {
                "commission": "Provision",
                "commission_show": "P. anzeigen",
                "lastlogin": "Login",
                "create": "Show hinzufügen",
                "tt_commission": "Anteil an der Provision in Prozent",
                "tt_commission_show": "Provision im Login-Bereich der Show anzeigen?",
                "tt_login": "Letztes Login",
                "tt_avg_duration": "Durchschnittliche Haltezeit",
                "tt_rating": "Durchschnittliche Bewertung der User",
                "tt_red": "Muss vervollständigt werden",
                "tt_yellow": "Sollte vervollständigt werden"
            },
            "agb_changed": {
                "title": "AGB aktualisiert",
                "p1": "Die allgemeinen Geschäftsbedingungen wurden aktualisiert.",
                "p2": "Bitte akzeptiere die neuen <a class=\"text-dark\" style=\"text-decoration: underline\" href=\"{url}\" target=\"_blank\">AGB</a>, um fortzufahren.",
                "accept": "Akzeptieren",
                "later": "Später"
            }
        },
        "profile": {
            "adminlocked": "Die Einstellungen des Profils wurden deaktiviert.",
            "language_adminlocked": "Die Einstellung der Sprachen wurden deaktiviert.",
            "profile": {
                "about_you": "Über dich",
                "slogan": "Slogan",
                "description": "Beschreibung",
                "hobbies": "Hobbies",
                "bday": "Geburtstag",
                "body_features": "Merkmale",
                "bust_size": "Oberweite",
                "cupsize": "Oberweite",
                "height": "Größe",
                "hair_color": "Haarfarbe",
                "haircolor": "Haarfarbe",
                "piercing": "Piercing",
                "eye_color": "Augenfarbe",
                "eyescolor": "Augenfarbe",
                "body": "Figur",
                "skin_color": "Hautfarbe",
                "skincolor": "Hautfarbe",
                "hair_length": "Haare",
                "hairlength": "Haare",
                "intimate_shaving": "Rasur",
                "shave": "Rasur",
                "zodiac": "Sternzeichen",
                "sexuality": "Sexuality",
                "gender": "Geschlecht",
                "orientation": "Ausrichtung",
                "sexualtendence": "Ausrichtung",
                "erotic_interests": "Erotische Interessen",
                "sexpref": "Erotische Interessen",
                "add_fetish": "Fetisch hinzufügen",
                "character_features": "Charakter",
                "character": "Charakter",
                "add_feature": "Eigenschaft hinzufügen",
                "languages": "Sprachen",
                "add_language": "Sprache hinzufügen",
                "language_very_good": "sehr gut",
                "language_good": "gut",
                "language_some": "ein wenig",
                "location": "Ort",
                "city": "Stadt",
                "country": "Land",
                "tooltips": {
                    "x_of_y_confirmed": "{x}/{y} bestätigt",
                    "x_of_y_pending": "{x}/{y} Bestätigung ausstehend",
                    "x_of_y_rejected": "{x}/{y} abgelehnt"
                }
            },
            "account": {
                "heading": "Account Einstellungen",
                "show_name": "Showname",
                "show_login": "Showlogin",
                "password": "Passwort",
                "repeat_password": "Passwort wiederholen",
                "email": "E-Mail",
                "send_password": "Passwort per E-Mail versenden",
                "send_password_short": "Per E-Mail versenden",
                "password_hidden_placeholder": "Aus Sicherheitsgründen hier nicht angezeigt",
                "errors": {
                    "name_unique": "Name ist bereits vergeben",
                    "login_unique": "Login ist bereits vergeben",
                    "referrer_valid": "Werber-Id ungültig"
                }
            }
        },
        "tax": {
            "payout_suspended": "Auszahlungen werden ausgesetzt!",
            "payout_suspended2": "Die nächste Auszahlung wird ausgesetzt. Bitte fülle das DAC7-Interview so schnell wie möglich aus.",
            "payout_suspended3": "Spätestens bis zum 30. April 2024.",
            "dac7_btn_init": "Interview jetzt starten",
            "dac7_btn_edit": "Daten bearbeiten",
            "dac7_btn_finish": "Interview abschließen",
            "dac7_title": "DAC7-Steuerinterview",
            "dac7_introduction": "Gemäß EU-Vorschriften (umgangssprachlich als DAC7 bezeichnet) sind digitale Plattformen verpflichtet,\n                                    der EU gegenüber Angaben zu Einnahmen ihrer Nutzer zu machen.\n                                    Dies betrifft alle Nutzer mit Wohnsitz/Firmensitz in der EU.",
            "dac7_introduction_2": "Bitte fülle dazu das DAC7-Steuerinterview aus. Das sollte nicht länger als 5 Minuten dauern.\n                                    Wir sind verpflichtet Auszahlungen auszusetzen, bis uns alle erforderlichen Daten vorliegen.",
            "classification_title": "Wie lautet deine Steuerklassifizierung?",
            "classification_hint": "Wenn du dir nicht sicher bist, solltest du \"Einzelunternehmer\" auswählen",
            "classification_individual": "Einzelperson / Einzelunternehmer",
            "classification_entity": "Juristische Person / Unternehmen",
            "personal_data_title": "Persönliche Daten",
            "legal_address_type": "Adresstyp",
            "vat_invalid": "Die Umsatzsteuernummer konnte nicht validiert werden. Bitte stelle sicher, dass die Umsatzsteuernummer zu dem Land deiner Adresse passt. Klicke auf Speichern, um erneut zu prüfen.",
            "vat_invalid_unknown": "Die Umsatzsteuernummer kann im Moment nicht validiert werden. Probiere es später erneut. Oder fahre fort, dann übernehmen wir die Prüfung für dich.",
            "vat_waiting": "Die Umsatzsteuernummer wird überprüft",
            "vat_invalid2": "Wir konnten deine USt-ID nicht validieren. Bitte überprüfe deine Eingabe!",
            "vat_hint": "Die Umsatzsteuer-Identifikationsnummer (falls vorhanden) wird für die Provisions-Abrechnungen benötigt",
            "tin_invalid": "Die TIN konnte nicht validiert werden. Bitte stelle sicher, dass die TIN zu dem ausgwählten Land passt. Klicke auf Speichern, um erneut zu prüfen.",
            "vat_hint1": "Wenn du als Einzelperson keine Umsatzsteuernummer hast, kannst du dieses Feld leer lassen",
            "no_tin": "Ich habe keine Steueridentifikationsnummer",
            "tin_hint": "Wo finde ich meine TIN? (offizielle EU-Webseite)",
            "tin_hint2": "Du musst die TIN angeben, die von dem Land ausgestellt wurde, in dem sich dein Hauptwohnsitz befindet.\n                    Das Fehlen dieser Angabe kann leider nur in Ausnahmefällen akzeptiert werden!",
            "tin_hint3": "Bei Unternehmen gilt für viele EU-Länder leider eine andere Regel, was hier genau als \"TIN\" eingetragen werden muss.\n            Bitte frage deinen Steuerberater oder deine Finanzbehörde, falls du hier nicht sicher bist.",
            "save_hint": "Du kannst deine Daten jederzeit speichern. Fahre im Bereich \"Abschließen\" fort, nachdem du alles ausgefüllt hast. Erst dann werden deine Eingaben geprüft.",
            "complete_title": "Abschließen",
            "complete_check": "Hiermit bestätige ich, dass alle Angaben vollständig und wahrheitsgemäß sind.",
            "complete_btn": "Abschließen und zur Überprüfung vorlegen",
            "status_rejected": "abgelehnt",
            "status_init": "bitte abschließen",
            "status_waiting": "wird geprüft",
            "status_confirmed": "erfolgreich geprüft",
            "confirm_account_holder": "Hiermit bestätige ich, dass ich selbst der Kontoinhaber bin.",
            "account_holder_info_hint": "Bitte gib <u>alle</u> bekannten Informationen zum Kontoinhaber an.\n            <br/><br/><b>Bei fehlenden oder unvollständigen Informationen\n            werden keine weiteren Auszahlungen getätigt!</b>",
            "status_waiting_hint_p1": "Deine Eingaben werden jetzt überprüft.",
            "status_waiting_hint_p2": "Nach Abschluss der Überprüfung kannst du deine Daten wieder anpassen, falls dies erforderlich sein sollte.",
            "status_rejected_hint_p1": "Deine Eingaben konnten nicht bestätigt werden.",
            "status_rejected_hint_p2": "Beachte bitte die Hinweise, die wir dir hierzu zugesendet haben. Überarbeite deine Eingaben und schließe das Formular erneut ab.",
            "status_data_changed_hint_p1": "Bitte überprüfe deine Angaben.",
            "status_data_changed_hint_p2": "Du hast deine Stammdaten geändert oder Dokumente gelöscht. Bitte überprüfe deine Eingaben und schließe das Formular erneut ab.",
            "status_confirmed_hint_p1": "Deine Eingaben wurden erfolgreich bestätigt.",
            "status_confirmed_hint_p2": "Wenn du deine Angaben jetzt änderst, müssen diese erneut überprüft werden!",
            "clearing_link": "Die Einstellungen für dein Finanzkonto findest du unter <a href=\"{url}\">{txt}</a>.",
            "legal_address_types_OECD301": "Geschäfts- oder Wohnadresse",
            "legal_address_types_OECD302": "Wohnadresse",
            "legal_address_types_OECD303": "Geschäftsadresse",
            "legal_address_types_OECD304": "Eingetragener Sitz",
            "legal_address_types_OECD305": "nicht näher bezeichnet",
            "in_types": {
                "BRN": "Handelsregisternummer (HR/BRN)",
                "IIN": "Individual Identification Number (IIN)",
                "LEI": "Legal Entity Identifier (LEI)",
                "EIN": "Entity Identification Number (EIN)",
                "Other": "Andere"
            }
        },
        "broadcast": {
            "download_title": "Neueste Sender-Software",
            "download_win": "Download v{version} für Windows",
            "download_win_title": "Neueste Windows-Software",
            "download_mac": "Download v{version} für Mac",
            "download_mac_title": "Neueste Mac-Software",
            "open_in_browser": "Jetzt senden!",
            "open_in_browser_title": "Ohne Download senden",
            "exclusive_mode": "Exklusiv-Chat-Mode",
            "exclusive_mode_no": "Nein",
            "exclusive_mode_separee": "Separee",
            "exclusive_mode_single": "Single-User-Modus",
            "price_factor": "Preisfaktor",
            "register_phone_service": "Jetzt für den Telefon-Service registrieren!",
            "cannot_go_online": "Du kannst im Moment nicht senden",
            "reasons": {
                "statusid": "Die Show muss vom Support freigeschaltet werden",
                "agechecked": "Die Altersverifizierung ist noch nicht abgeschlossen",
                "disabled": "Die Show wurde im Master-Account deaktiviert",
                "previewok": "Es müssen noch Vorschaubilder hochgeladen/freigeschaltet werden",
                "galleryok": "Es müssen noch Gratisgalerie-Bilder hochgeladen/freigeschaltet werden",
                "disableduntil": "Vorübergehend gesperrt bis: {date}",
                "documents": "Es sind Dokumente erforderlich, um dein Profil zu vervollständigen"
            },
            "chrome": {
                "link": "Bitte verwende Google-Chrome",
                "tooltip": "Du kannst auch andere Browser (Firefox, Opera, ...) verwenden. Um die besten Ergebnisse zu erzielen, solltest du Chrome verwenden."
            },
            "test_chat": {
                "btn": "Test-Chat",
                "tooltip_offline": "Bitte gehe online, um den Test-Chat zu aktivieren"
            }
        },
        "navigation": {
            "media": "Bilder/Videos",
            "galleries": "Bilder",
            "videos": "Videos",
            "profile": "Profil",
            "profile_data": "Daten",
            "profile_clearing": "Abrechnung",
            "profile_documents": "Dokumente",
            "account": "Account",
            "verification": "Altersverifizierung",
            "statistics": "Statistiken",
            "messages": "Nachrichten",
            "contacts": "Kontakte",
            "support": "Support",
            "broadcast": "Senden",
            "settings": "Einstellungen",
            "macros": "Makros",
            "phoneservice": "Telefon Service",
            "mastersettings": "Einstellungen",
            "messagessettings": "Einstellungen",
            "getmore": "Get More",
            "bookings": "Abrechnung",
            "conditions": "Konditionen",
            "shows": "Shows",
            "back_to_master": "Zurück zum Master-Account",
            "back_to_master_dd": "Master-Account",
            "logout": "Ausloggen",
            "lang": "Sprache",
            "master_login": "Master-Login",
            "master_chat": "Chat",
            "faq": "FAQ",
            "documents": "Dokumente",
            "toy-control": "Lovense Toys"
        },
        "messages": {
            "support_messages": "Meine Support-Nachrichten",
            "support_messages_shows": "Support-Nachrichten meiner Shows",
            "support_inbox": "Meine Inbox",
            "support_inbox_shows": "Shows Inbox",
            "user_messages": "Unterhaltungen",
            "settings": "Nachrichten-Einstellungen",
            "all_shows": "Alle Shows",
            "last_chat": "letzter chat",
            "coins_spent": "Coins ausgegeben",
            "total_chattime": "Zeit im Chat",
            "last_chats": "Letzte Chats",
            "stats": "Stats",
            "time_in_chat": "Zeit im Chat",
            "minutes_in_chat": "Minuten im Chat",
            "messages_written": "Nachrichten geschrieben",
            "videos_bought": "Videos gekauft",
            "galleries_bought": "Galerien gekauft",
            "coins_spent_chat": "Coins im Chat ausgegeben",
            "coins_spent_messages": "Coins für Nachrichten ausgegeben",
            "coins_spent_galleries": "Coins für Galerien ausgegeben",
            "coins_spent_videos": "Coins für Videos ausgebeben",
            "coins_spent_you": "Coins insgesamt ausgegeben",
            "contacts": "Kontakte",
            "contact_established": "Kontakt hergestellt",
            "no_messages_yet": "Noch keine Nachrichten",
            "add_favorite": "Als Favorit hinzufügen",
            "remove_favorite": "Favorit entfernen",
            "add_hidden": "Für diese Sitzung Ausblenden",
            "remove_hidden": "Wieder anzeigen",
            "blocked_shows_only": "Bitte als Show einloggen, um User zu blockieren",
            "add_blocked": "Blockieren",
            "remove_blocked": "Blockieren aufheben",
            "send_message": "Nachricht senden",
            "unblock_first": "Nachrichten können nicht an blockierte/ausgeblendete User geschrieben werden",
            "premium": "premium",
            "you": "Du",
            "you_via_master": "Du (via master)",
            "premium_message_success": "{x} Coins BEANSPRUCHT!",
            "premium_message_available": "Premium: {x} Coins",
            "premium_message_missed": "{x} coins VERPASST!",
            "premium_tooltip_success": "Du hast diese Vergütung erfolgreich beansprucht",
            "premium_tooltip_default": "Antworte innerhalb 24 Stunden, um die Prämie zu beanspruchen",
            "premium_tooltip_until": "Antworte bis {time}, um die Prämie zu beanspruchen",
            "mark_as_read": "Als gelesen markieren",
            "send": "Senden",
            "select_to_answer": "Bitte wähle eine Nachricht aus, auf die du antworten möchtest",
            "no_conversations1": "Du hast noch keine Unterhaltungen.",
            "no_conversations2": "Klicke auf {action}, um einen Chatpartner auszuwählen.",
            "choose_conversation": "Bitte wähle eine Unterhaltung aus.",
            "no_messages": "Noch keine Nachrichten.",
            "start_conversation_here": "Starte die Unterhaltung hier",
            "no_contacts_found": "Keine Kontakte gefunden",
            "no_contacts_yet": "Du hast noch keine Kontakte. Nachdem User in deinem Chat waren, findest du sie hier.",
            "delete_conversation": "Die Unterhaltung mit {nickname} wirklich entfernen?",
            "member_deleted": "Dieser Kontakt kann im Moment keine Nachrichten empfangen.",
            "messages_error": "Die Nachrichten konnten nicht geladen werden. Erneut versuchen: ",
            "filter": "Filter",
            "filters": {
                "chatted_once": "hat mindestens einmal gechattet",
                "chatted_10": "hat mindestens 10 Minuten gechattet",
                "chatted_30": "hat mindetsens 30 Minuten gechattet",
                "bought_video": "hat Videos gekauft",
                "bought_no_video": "hat KEIN Video gekauft",
                "bought_gallery": "hat Galerien gekauft",
                "bought_no_gallery": "hat KEINE Galerie gekauft",
                "hidden": "ist ausgeblendet",
                "blocked": "ist blockiert",
                "favorite": "ist Favorit"
            },
            "welcome_messages": {
                "headline": "Automatische Nachrichten",
                "title1": "Opener-Message",
                "subtitle1": "Sende automatische Nachrichten an User, zu denen du noch keinen Kontakt hattest. Erweitere so deine Kontaktliste und bringe mehr User dazu, dir zu schreiben oder deinen Chat zu besuchen."
            }
        },
        "statistics": {
            "title": "Statistik",
            "current_turnover": "Umsatz diesen Monats",
            "current_online_time": "Onlinezeit diesen Monats",
            "average_rating": "Durchschn. Bewertung",
            "average_holding_time": "Durchschn. Haltezeit",
            "sales_detail": "Umsatzdetails vom {date}",
            "online_detail": "Onlinezeiten vom {date}",
            "sales": "Umsatz von {startdate} bis {stopdate}",
            "online": "Onlinezeiten von {startdate} bis {stopdate}",
            "no-data": "Keine Daten vorhanden",
            "live_data_hint": "<span class=\"text-warning\">Markierte Werte</span> sind noch nicht archiviert und können sich ändern",
            "total": "Gesamt",
            "date": "Datum",
            "sessions": "Sitzungen",
            "duration": "Dauer",
            "minutes": "Minuten",
            "online_minutes": "Online-Minuten",
            "chat_minutes": "Chat-Minuten",
            "hold_time": "Haltezeit",
            "turnover": "Umsatz",
            "turnover_master": "Umsatz Master",
            "turnover_show": "Umsatz Show",
            "start": "Anfang",
            "end": "Ende",
            "program": "Programm",
            "showname": "Showname",
            "user": "User",
            "type": "Typ",
            "section-table": "Details",
            "section-turnover": "Umsatz",
            "section-onlinetimes": "Onlinezeiten",
            "section-onlinetimes-distribution": "Onlinezeiten-Verteilung",
            "section-chatsession-distribution": "Chatsitzungs Verteilung",
            "timezone-hint": "Alle Zeitangaben in {tz}",
            "session_type_All": "Alle",
            "session_type_Show": "Show",
            "session_type_Bilder": "Bilder",
            "session_type_Videos": "Videos",
            "session_type_Voyeurchat": "Voyeur",
            "session_type_Separee": "Separee",
            "session_type_ruf777": "ruf777",
            "session_type_Message": "Message",
            "session_type_Tip": "Tip",
            "session_type_ToyControl": "ToyControl",
            "session_type_Master-Chat": "TestChat"
        }
    },
    "en": {
        "auth": {
            "login": "Login",
            "username": "Username",
            "password": "Password",
            "password_confirm": "Repeat Password",
            "disabled": "Access to this account is disabled",
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "email_confirm_success": "The email address has been successfully confirmed!"
        },
        "general": {
            "add": "add",
            "back": "back",
            "next": "next",
            "search": "search",
            "year": "Year",
            "month": "Month",
            "day": "Day",
            "or": "or",
            "default": "default",
            "days": {
                "mon": {
                    "short": "Mon",
                    "long": "Monday"
                },
                "tue": {
                    "short": "Tue",
                    "long": "Tuesday"
                },
                "wed": {
                    "short": "Wed",
                    "long": "Wednesday"
                },
                "thu": {
                    "short": "Thu",
                    "long": "Thursday"
                },
                "fri": {
                    "short": "Fri",
                    "long": "Friday"
                },
                "sat": {
                    "short": "Sat",
                    "long": "Saturday"
                },
                "sun": {
                    "short": "Sun",
                    "long": "Sunday"
                }
            },
            "address": "Address",
            "city": "City",
            "zip": "ZIP",
            "country": "Country",
            "email": "Email",
            "homepage": "Homepage",
            "telephone": "Telephone",
            "mobile": "Mobile",
            "company": "Company",
            "name": "Name",
            "forename": "Forename",
            "surname": "Surname",
            "street_nr": "Street/Nr.",
            "zip_city": "ZIP/City",
            "pob": "P.O. Box",
            "birthday": "Birthday",
            "birthday_invalid": "Please enter a valid date of birth",
            "vat": "VAT ID",
            "tin": "Tax Identification Number (TIN)",
            "in": "Identification Number (IN)",
            "in_type": "IN Type",
            "birth_place": "Birth Place",
            "former_country_name": "Former Country Name",
            "financial_identifier": "Financial Identifier",
            "tax_information": "Tax information",
            "open": "Open",
            "save": "Save",
            "send": "Send",
            "discard": "Discard",
            "saved": "Saved",
            "ok": "OK",
            "cancel": "Cancel",
            "descending": "descending",
            "ascending": "ascending",
            "yes": "Yes",
            "no": "No",
            "active": "active",
            "inactive": "inactive",
            "loading": "loading",
            "last_online": "Last online",
            "never": "Never",
            "close": "Close",
            "optional": "optional",
            "choose_option": "Please choose an option...",
            "referrer": "Referrer ID",
            "your_email": "Your Email Address",
            "subject": "Subject",
            "message": "Message",
            "check_tac": "I have read the {link} terms and conditions</a> and I agree to them.",
            "check_privacy": "I hereby consent to the storage and processing of my personal data. I have taken note of the information in the {link} data protection declaration</a> regarding the processing of my personal data and data protection.",
            "throttled": "Please wait before retrying.",
            "server_error": "An unknown error occured. Please try again later.",
            "unkown_error": "An unknown error occured.",
            "form_invalid": "Data could not be saved",
            "order_by": {
                "id": "Order by ID",
                "rating": "Order by rating",
                "views": "Order by views",
                "sales": "Order by sells",
                "title": "Order by title",
                "duration": "Order by duration"
            },
            "german": "German",
            "english": "English",
            "status_waiting": "Waiting for approval",
            "status_accepted": "Approval successful",
            "status_rejected": "Rejected",
            "select_all": "Select all",
            "select_none": "Unselect all",
            "setting_disabled_by_admin": "This setting is not available",
            "settings_locked_by_admin": "Please contact support to change this setting",
            "setting_disabled_by_master": "This setting is only available to the master account",
            "errors": {
                "419": "The security token has expired. Please try again!",
                "404": "The page you asked for does not exist."
            }
        },
        "macros": {
            "heading": "Macros",
            "greeting": "Greeting",
            "greeting_sub": "Choose what message the user receives when he joins your chat.",
            "description": "If you use the same text in chat a lot you can use macros instead. While chatting you can insert your text snippet using the designated key (e.g. F1). You can use ##username## and ##showname## as placeholder."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "getmore": {
            "p1": "For every payment made by a user you have referred, you will receive an additional 40% as an advertising bonus!",
            "p2": "As soon as someone registers through you, you earn with every payment** - that easy! In the best case, earn twice with a live show + advertising bonus.",
            "p3": "Marketing tools, statistics and billing data can be found on the affiliate program page.",
            "p_register": "For this you need an advertising account (partner account) at 777partner.com. Simply click on the following button. The registration will be done automatically for you, of course free of charge and without obligation.",
            "getmore_active": "activated",
            "getmore_inactive": "Registration pending",
            "payout_title": "GetMore payout (90 days)",
            "user_title": "User advertising (90 days)",
            "user": "Users with sales",
            "btn_register": "Register Partner Account",
            "partner_link": "To Partner Program",
            "directlink": "Direct link for your show",
            "select_show": "Please select a show",
            "affiliate_link": "Advertise the entire program",
            "stats_hint": "Values can vary. You can see the final figures on the affiliate program page.",
            "terms_hint": "Details on advertising fees can be found in the general terms and conditions of 777partner.com.",
            "error": "An error has occurred. Please contact support if the error persists.",
            "account_error": "The partner account could not be loaded. Please contact support if the error persists.",
            "partner_toc": "Recruit new users with our affiliate program and increase your earnings with every payment from your referred user",
            "referrer_toc": "Recruit more Master Accounts and profit from your friends’ turnover",
            "partner_title": "Affiliate program - Recruit new users and receive a share of the revenue",
            "referrer_title": "Recruit Master Account",
            "referrer_text": "Do you have a friend who also wants to become a camgirl? Use this affiliate link and receive at least €50 if the referred Master Account receives a payout for three consecutive months. A higher payout amount is possible after individual review!",
            "referrer_hint": "This is a non-binding offer available only to Master Accounts who actively run their own shows on our platforms and receive regular payouts. The shows of the referred Master Account must not already be broadcasting on our platform."
        },
        "validation": {
            "login_characters": "The following characters are not allowed for login: {chars}",
            "password_characters": "The following characters are not allowed for password: {chars}",
            "showname_characters": "The following characters are not allowed for showname: {chars}",
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "languages": {
                    "required": "Please choose at least one language",
                    "min": "Please choose at least one language",
                    "max": "Please choose a maximum of four languages"
                },
                "erotic_interests": {
                    "required": "Please choose at least one erotic interes",
                    "min": "Please choose at least one erotic interes",
                    "max": "Please choose a maximum of five erotic interess"
                },
                "character_features": {
                    "required": "Please choose at least one character feature",
                    "min": "Please choose at least one character feature",
                    "max": "Please choose a maximum of ten character features"
                },
                "bust_size_number": {
                    "min": "Please choose a reasonable bust size"
                },
                "city": {
                    "min": "Please choose a city"
                },
                "country": {
                    "min": "Please choose a country"
                },
                "orientation": {
                    "min": "Please choose an orientaion"
                },
                "gender": {
                    "min": "Please choose a gender"
                },
                "reportable_seller.addresses.*.city": {
                    "required": "A city must be specified for the address"
                },
                "reportable_seller.addresses.*.country_code": {
                    "required": "A country must be specified for the address"
                },
                "reportable_seller.seller_type": {
                    "required": "Please select a tax classification"
                },
                "reportable_seller.financial_identifiers.*.identifier": {
                    "required": "Financial Account must be specified"
                },
                "reportable_seller.financial_identifiers.*.account_number_type": {
                    "required": "Financial Account Type must be specified"
                },
                "reportable_seller.financial_identifiers.*.account_holder_name": {
                    "required_if": "Account holder must be specified"
                },
                "reportable_seller.financial_identifiers.*.other_info": {
                    "required_if": "Information about the alternate account holder must be specified"
                },
                "reportable_seller.financial_identifiers.*.other_info_address": {
                    "required_if": "Address of the alternate account holder must be specified"
                },
                "reportable_seller.first_name": {
                    "required_if": "Forename must be specified"
                },
                "reportable_seller.last_name": {
                    "required_if": "Surname must be specified"
                },
                "reportable_seller.birth_date": {
                    "required_if": "Birthday must be specified"
                },
                "reportable_seller.company_name": {
                    "required_if": "Company must be specified"
                },
                "reportable_seller.tins.*.tin": {
                    "required_if": "Tax Identification Number (TIN) must be specified"
                },
                "reportable_seller.ins.*.in": {
                    "required_if": "Identification Number (IN) must be specified"
                },
                "reportable_seller.ins.*.issued_by": {
                    "required_if": "Identification Number (IN): a country must be specified"
                },
                "reportable_seller.financial_identifiers.*.other_info_tin_country": {
                    "required_with": "Tax Identification Number (TIN): a country must be specified"
                },
                "reportable_seller.tins.*.issued_by": {
                    "required_with": "Tax Identification Number (TIN): a country must be specified"
                },
                "reportable_seller.tins.0.issued_by": {
                    "in": "Country (TIN) must match the country of the address"
                }
            },
            "attributes": {
                "doctype": "Type",
                "file": "File",
                "name": "Name",
                "date": "Date",
                "cam_admin.provision": "commission",
                "priceperminuteid": "user price",
                "price": "price",
                "password_confirm": "repeat password",
                "contact.email": "email",
                "contact.vorname": "forename",
                "contact.nachname": "surname",
                "contact.strasse": "street",
                "contact.plz": "ZIP",
                "contact.stadt": "city",
                "contact.nationID": "country",
                "contact.telefon": "telephone",
                "contact.handy": "mobile",
                "contact.homepage": "homepage",
                "contact.firma": "company",
                "contact.birthday": "birthday",
                "contact.company_reg_number": "Business Reg. Nr.",
                "paxum_account.email": "account",
                "paxum_account.email_confirm": "confirm account",
                "paxum_account.type": "Paxum Account Type",
                "bank_account.kontoBesitzer": "account holder",
                "bank_account.blz": "BLZ",
                "bank_account.bankName": "bank name",
                "bank_account.kontoNr": "account number",
                "bank_account.iban": "IBAN",
                "bank_account.bic": "BIC",
                "bank_account.swift": "SWIFT/BIC",
                "bank_account.banksitzID": "bank country",
                "bank_account.reference": "reference",
                "slogan_de": "Slogan (DE)",
                "slogan_en": "Slogan (EN)",
                "description_de": "Description (DE)",
                "description_en": "Description (EN)",
                "hobby_de": "Hobbies (DE)",
                "hobby_en": "Hobbies (EN)",
                "hobbies_de": "Hobbies (DE)",
                "hobbies_en": "Hobbies (EN)",
                "bust_size": "Cup Size/Bust",
                "breastscale": "Bust",
                "hair_color": "Hair color",
                "hair_length": "Hairs",
                "eye_color": "Eye color",
                "shaving": "Shave",
                "skin_color": "Skin color",
                "body": "Body",
                "height": "Height",
                "piercing": "Piercing",
                "orientation": "Orientation",
                "languages": "Languages",
                "beschreibung": "Description",
                "kurztext": "Title",
                "beschreibung_eng": "Description (en)",
                "kurztext_eng": "Title (en)",
                "beschreibung_fsk18": "Description (de - hard)",
                "kurztext_fsk18": "Title (de - hard)",
                "translations.de.description": "Description (DE)",
                "translations.de.title": "Title (DE)",
                "translations.en.description": "Description (EN)",
                "translations.en.title": "Title (EN)",
                "reportable_seller.birth_city": "Birth Place (City)",
                "reportable_seller.birth_country_code": "Birth Place (Country)",
                "reportable_seller.birth_former_country_name": "Birth Place (Former Country Name)"
            }
        },
        "phoneservice": {
            "errors": {
                "pin_invalid": "Der eingegebene Code ist ungültig",
                "service_error": "Die Einrichtung des Dienstes ist fehlgeschlagen. Bitte wende dich an den Support, falls dieser Fehler bestehen bleibt.",
                "service_error2": "Der Rückruf konnte nicht gestartet werden. Bitte wende dich an den Support, falls dieser Fehler bestehen bleibt."
            },
            "status": {
                "registered": "Registriert",
                "paused": "Pausiert",
                "active": "Aktiviert",
                "not_registered": "Nicht registriert",
                "busy": "Beschäftigt",
                "not_available": "Nicht verfügbar"
            }
        },
        "imprint": {
            "header": "Imprint",
            "support": "Support",
            "youth": "Youth protection commissioner",
            "operator": "Operator",
            "content": "Content accountability"
        },
        "public": {
            "legacy_login": {
                "h": "We've moved!",
                "p1": "Click the login button",
                "p2": "or go to the following address in your browser:",
                "login": "Login",
                "help1": "Sending via webcam and managing your account can now be done conveniently via your browser.",
                "help2": "You can now close and uninstall the software \"777 ShowSoft\"."
            },
            "nav": {
                "home": "Home",
                "start": "Start",
                "register": "Register as an amateur or agency",
                "admin_area": "Admin Area",
                "logout": "Logout",
                "sign_up": "Sign up",
                "additional_questions": "Additional Questions?",
                "first_steps": "First steps / What happens next?"
            },
            "register": {
                "header": "Register now as a performer or agency",
                "submit": "Register now",
                "success": "The registration was successful! You will receive an email for confirmation, shortly."
            },
            "register_done": {
                "header": "Thanks a lot!",
                "p1": "To confirm the registration, we sent an email to <b>{email}</b>",
                "p2": "Please follow the instructions in the email to complete the registration.",
                "email_confirmation": "Repeat email",
                "resend": "Didn't receive an email?",
                "resend_submit": "Resend email",
                "resend_success": "The confirmation email was sent again!",
                "change": "Typo? Enter new email address:",
                "change_submit": "Save and resend confirmation email",
                "change_success": "The confirmation email has been sent to the new email address!",
                "hint": "Add <b>{email}</b> as a contact in your address book to prevent our email from being classified as spam."
            },
            "side_h1": "Forgotten your login information?",
            "side_pw_reset_link": "Reset password",
            "side_h2": "Support",
            "side_p2": "Our support team is always available for you. We will try to help you as fast and uncomplicated as possible.",
            "side_support_link": "Contact Support",
            "side_h3": "Show & performer blog",
            "side_p3": "For news, a wealth of information and descriptions of successful amateur performers on 777, take a look at our blog."
        },
        "passwords": {
            "password": "Passwords must be at least eight characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "If the given username is valid, we have sent a link to reset the password to the corresponding email address!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "send_button": "Send Password Reset Link",
            "reset_button": "Save new password",
            "error": "An error has occurred. Please try again later.",
            "reset_master": "Reset master password",
            "reset_show": "Reset show password",
            "reset_link": "Forgot password?",
            "register_link": "No account yet?",
            "login_link": "Login"
        },
        "media": {
            "duration": "Duration",
            "price": "Price",
            "sales": "Sales",
            "rating": "Rating",
            "pictures": "Pictures",
            "resolution": "Resolution",
            "views": "Views",
            "preview_gallery": "Preview",
            "preview_gallery_header": "Preview Pictures - No Hardcore!",
            "preview_gallery_descr1": "You need 3 preview pics in a <b>very good quality</b> and a <b>minimum image size of {width}x{height} Pixel (landscape)</b>.",
            "preview_gallery_descr2": "For your success, the images should be \"advertising\" and make you want more. They are used in sedcards and advertising tools.",
            "preview_gallery_descr3": "Use <b>current pictures</b>, which are not older than 1 year.",
            "id_cards": "ID",
            "id_cards_header": "ID Images - Age Verification",
            "id_cards_descr1": "To confirm your identity and your age we need mandatory a high quality scan or photography of the front and back side of your identity-card or passport.",
            "id_cards_descr1_video": "To confirm the identity and age of ALL actors we need mandatory a high quality scan or photography of the front and back side of their identity-card or passport.",
            "id_cards_descr2": "In addition we need a \"Snapshot\" showing their ID-Card or Passport as close as possible, right sided next to their face.",
            "id_cards_descr3": "Please choose the ID-Cards of ALL present actors.",
            "documents": "Documents",
            "documents_header": "Documents",
            "documents_upload": "Upload",
            "documents_uploads": "Uploaded Files",
            "documents_uploads_empty": "No uploads yet",
            "document_overview_header": "Document Overview",
            "documents_shows_home_alert": "Documents are required to complete your profile!",
            "documents_shows_home_link": "Manage Documents",
            "document_tooltip_required": "Upload required",
            "document_template_link": "Form",
            "document_title_release": "Release Form - Statement On Copyrights",
            "document_description_release": "With this form you assure that you are not violating any third party rights.\n                                     You also declare that you are responsible for all content\n                                     and provide it in your own will. You further acknowledge that\n                                     we are allowed to publish your content.",
            "document_description_ol1": "Please download the form here",
            "document_description_ol2": "Fill out the printed form and sign it",
            "document_description_ol3": "Scan or take a photo of the completed form before uploading it (.pdf, .jpg, .png)",
            "document_tip_1": "Tip",
            "document_tip_2": "Fill out the form and sign it without a printer",
            "free_gallery": "Free Gallery",
            "free_gallery_header": "Free Gallery - Hardcore Allowed!",
            "free_gallery_descr1": "Image size of min {width}x{height} Pixel as a precondition!",
            "free_gallery_descr2": "When the Gallery is full, you must first delete an image, in order to upload a new one. It is also possible to create additional chargeable galleries.",
            "free_gallery_descr3": "No duplicates of the preview images here!",
            "pay_galleries": "Pay Galleries",
            "contests": "Contests",
            "preview_video": "Preview Video",
            "preview_video_header": "Preview Video - No Hardcore!",
            "pay_videos": "Pay Videos",
            "pay_videos_header": "Pay Video - Hardcore Allowed!",
            "confirm_remove": "Really delete image? You can't undo that!",
            "confirm_remove_list": "Really delete selected images? You can't undo that!",
            "confirm_delete_gallery": "Really delete gallery with all images? You can't undo that!",
            "confirm_delete_gallery_ok": "Yes, delete gallery!",
            "confirm_delete_video": "Really delete video? You can't undo that!",
            "confirm_delete_video_ok": "Yes, delete video!",
            "confirm_delete_document": "Delete this document? Depending on the document type, you may not be able to go online, until you uploaded a new document of this type.",
            "confirm_delete_document_master": "Delete this document? Depending on the document type, you may no longer receive payouts until you upload a new document of that type.",
            "confirm_delete_document_dac7": "Delete this document? You must complete the DAC7 tax interview again. Until then, no payouts are possible.",
            "confirm_discard": "Discard changes?",
            "confirm_discard_ok": "Discard changes!",
            "confirm_cancel": "Cancel",
            "edit_upload_hint": "Open new Image in Editor and upload",
            "drag_hint": "Drag files or click to upload!",
            "drag_hint2": "Drag files or click to choose file!",
            "max_images_reached": "Maximum reached",
            "min_image_size": "Image too small",
            "min_image_size_with_hint": "Image too small {hint}",
            "wrong_preview_aspect_hint": "Preview images must be uploaded in landscape format",
            "file_not_supported": "File type not supported",
            "duplicate": "Image is a duplicate",
            "create_gallery": "New Gallery",
            "create_video": "New Video",
            "create_video_hint": "Please enter a title and description and hit save. When done, a video file can be uploaded.",
            "create_video_no_preview": "Reviewed preview video required",
            "edit_video": "Edit Video",
            "edit_gallery": "Edit Gallery",
            "create_in_process": "Please release this gallery first",
            "gallery_sold_hint": "Gallery has already been sold. Unlocked images cannot be deleted.",
            "gallery_sort_up": "Sort new images to the back",
            "gallery_sort_down": "Sort new images to the front",
            "gallery_sort_confirm": "Discard current sort?",
            "gallery_sort_hint": "Sort the images by drag and drop (<i class=\"fas fa-grip-horizontal\"></i>) or by upload order (<i class=\"fas fa-sort-up\"></i> <i class=\"fas fa-sort-down\"></i>).",
            "form": {
                "title": "Title",
                "description": "Description",
                "tags": "Tags",
                "price": "Retail price per picture",
                "gallerytype": "Youth Protection",
                "finish_gallery": "Release gallery for review",
                "finish_gallery_tip": "Please upload at least 5 images",
                "review_in_progress": "Review in progress"
            },
            "document_form": {
                "select": "Select file...",
                "upload": "Upload now",
                "already_uploaded": "already uploaded",
                "doctype_release": "Release Form",
                "doctype_financial_account": "Financial Account Holder Statement / Declaration Of Exemption",
                "doctype_other": "Other",
                "doctype_placeholder": "Which document should be uploaded?"
            },
            "video_form": {
                "description_soft": "Enter description here (soft version).",
                "title_soft": "Enter title here (soft version).",
                "title_hard": "Enter title here. Should be hardcore!",
                "description_hard": "Enter description here. Should be hardcore!",
                "price": "Retail price per minute",
                "confirm_save_reset_status": "The video will be reviewed and will not appear on the website during this time.",
                "video_status_2": "The video is beeing processed. As soon as processing is finished, it will be reviewed.",
                "video_status_3": "The video has been processed! It will we reviewed as soon as possible.",
                "confirm_upload": "Upload video file {file} now?",
                "other_actors": "There are other actors than me in this video"
            },
            "video_upload": {
                "start": "Start Upload",
                "max_file_size": "Maximum filesize 5000 MB",
                "preview_duration": "Minimum duration 30 seconds, only the first 40 seconds are used",
                "pay_duration": "Minimum duration 60 seconds",
                "min_dimensions": "At least 640x480 pixel resolution in good quality"
            },
            "video_thumbnail": {
                "upload_thumbnail": "upload thumbnail",
                "take_snapshot": "take snapshot",
                "move_right": "move right",
                "move_left": "move left",
                "save": "save snapshot",
                "abort": "abort",
                "invalid_proportions": "Invalid format. Please upload a picture in landscape format.",
                "invalid_height": "Please uploade a picture with at least {widthx}{height} pixels.",
                "invalid_width": "Please uploade a picture with at least {widthx}{height} pixels."
            },
            "errors": {
                "upload_error": "Upload failed. Flease try again.",
                "delete_image_agechecked": "Cannot remove id card. Please contact support.",
                "delete_image_gallery_sold": "Image cannot be deleted: gallery was sold.",
                "video_min_duration": "Video duration is too short!",
                "video_min_resolution": "Video resolution is too small!"
            }
        },
        "notes": {
            "dialog_title": "Notes",
            "placeholder": "Enter a name and other notes",
            "tooltip": "Notes"
        },
        "invoice": {
            "transaction": "Payout",
            "invoice": "Invoice",
            "paxum_id": "Paxum ID",
            "accound_holder": "Account holder",
            "bank": "Bank",
            "bank_id": "BIC",
            "bank_account_id": "IBAN",
            "balance": "Balance"
        },
        "contact": {
            "header": "Contact",
            "success": "The message has been sent!"
        },
        "editor": {
            "crop": "Crop to selection",
            "crop_short": "Crop",
            "left": "Rotate left",
            "left_short": "Rotate left",
            "right": "Rotate right",
            "right_short": "Rotate right",
            "rotate": "Rotate",
            "center": "Center image",
            "center_short": "Center",
            "reset": "Reset image",
            "reset_short": "Reset",
            "save": "Save changes and uplaod image",
            "save_short": "Save",
            "close": "Discard changes and close editor",
            "close_short": "Discard",
            "no_support": "This Browser is not supported. Please update!"
        },
        "lovense": {
            "app": {
                "title": "Service Status",
                "pending": "Pending",
                "instructions1": "To be able to use toy control in your chat, you have to set up the service once here:",
                "setup_now": "Setup service now",
                "setup_pending": "The service will be activated by support shortly.",
                "setup_rejected": "Unfortunately, the service cannot be used.",
                "setup_active": "The service was set up successfully and is active!",
                "setup_paused": "The service is currently inactive.",
                "status_not_set_up": "Not set up",
                "status_not_available": "Not available",
                "download": "Download <b><a target=\"_blank\" href=\"https://lovense.com/cam-model/extension\">Lovense Connect App</a></b> for computer or mobile",
                "start": "Start the app und connect your <a target=\"_blank\" href=\"https://lovense.com/public/store\">toy</a>",
                "start2": "The <a target=\"_blank\" href=\"https://lovense.com/bluetooth-adapter\">USB adapter</a> is also required for Windows",
                "start3": "Always make sure your <b>toy is charged</b>",
                "go_online": "Go online und and click the <button disabled class=\"btn btn-sm btn-primary\"><i class=\"fa fa-lush\"></i> LOVENSE</button> Button",
                "go_online2": "Scan the QR code if you are using the mobile app",
                "done": "Your users can activate your toy by leaving a tip"
            },
            "level": {
                "title": "Tip Levels",
                "level": "Level",
                "coins": "Coins",
                "duration": "Duration",
                "vibration": "Vibration",
                "seconds": "{seconds} seconds",
                "low": "low",
                "medium": "medium",
                "high": "high"
            },
            "auto_disable": {
                "days": "Time until deactivation: {days} days",
                "shortly": "The service will be deactivated shortly.",
                "info": "The service is automatically deactivated after a long period of inactivity. You can reactivate the service at any time."
            }
        },
        "master": {
            "base_data": "Base Data",
            "personal_data": "Personal Data",
            "clearing_options": "Clearing Options",
            "tax": "Tax",
            "confirmation_email_sent": "An email was sent to {email}. Please click on the link in the email to confirm your new email address.",
            "blocked_while_dac7_waiting": "Data cannot be changed while the DAC7 tax interview is being reviewed.",
            "conditions": {
                "header": "Master Rates",
                "th1": "End Customers Rate",
                "th2": "Master Comission"
            },
            "home": {
                "header": "Master Access / Main Administration",
                "newsletter": "Our last 5 newsletters",
                "todos": "To do",
                "todos_done": "Nothing to do",
                "todo_idcard": "ID is missing / not yet checked",
                "todo_documents": "Documents missing",
                "todo_profile": "Profile incomplete or waiting for confirmation from support",
                "todo_preview": "Preview images are missing / not yet checked",
                "todo_free": "Free gallery images missing / not yet verified",
                "todo_price": "Prices have to be set",
                "todo_pics": "Pictures in galleries are missing",
                "todos_paxum_title": "Complete Paxum Account",
                "todos_paxum_link": "Paxum Account",
                "show_listheader": "Shows",
                "showlist_online": "Now Online",
                "showlist_offline": "Offline",
                "showlist_disabled": "Inactive",
                "showlist_disabled_check": "Display deactivated shows",
                "tac": "Terms",
                "support_messages": "Support Messages",
                "support_messages_master": "Support to master",
                "support_messages_shows": "Support to show",
                "user_messages": "User Messages",
                "conversations": "Messages to shows",
                "premium_messages": "Premium messages",
                "todo_no_show": "Create a show now to get started!",
                "locked": "You are locked. Please contact support."
            },
            "clearing": {
                "show_id": "Show-ID on receipt",
                "show_name": "Showname on receipt",
                "factoring": "Payout at",
                "factoring_0": "Middle of the month",
                "factoring_1": "Beginning of the month (-2%)",
                "payout_type": "Payout via",
                "payout_type_0": "No Payout",
                "payout_type_1": "Wire transfer",
                "payout_type_3": "Paxum",
                "payout_limit": "Payout lower limit",
                "clearing_annotation": "Annotation on receipt",
                "clearing_annotation_hint": "(Optional - e.g. for accounting)",
                "fees": "Payout Fees",
                "fees_bank": "Bank transfer (worldwide): 0.00 EUR",
                "fees_bank_sub": "Outside SEPA: additional fees may be charged by the banks",
                "fees_paxum": "Paxum: only 0.99 EUR",
                "fees_paxum_sub": "Additional fees may be charged by the provider",
                "paxum_type": "Account Type",
                "paxum_type_choose": "please choose...",
                "paxum_type_personal": "Personal Account",
                "paxum_type_business": "Business Account",
                "paxum_data_hint": "For payouts via Paxum, the following information will be transmitted to Paxum Bank Limited.\n                                Please enter the information in your profile:"
            },
            "contact": {
                "email": "email",
                "vorname": "forename",
                "nachname": "surname",
                "birthday": "Birthday",
                "strasse": "street",
                "plz": "ZIP",
                "stadt": "city",
                "nationID": "country",
                "telefon": "telephone",
                "handy": "mobile",
                "homepage": "homepage",
                "firma": "company",
                "vat_id": "VAT ID",
                "company_reg_number": "Business Reg. Nr. (BRN)",
                "hint1": "Please ensure that you provide <b>all data</b> correctly and always state your <b>main residence</b>.\n                             Otherwise, a commission payment is unfortunately not possible.\n                             Regardless, a different location can be specified in each show profile.\n                             Only the location of the show profile is published for users!",
                "hint_*": "* Optional - Tell us how we can reach you",
                "hint_**": "** Optional - Required for some payout methods (e.g. Paxum)"
            },
            "account": {
                "identifier": "Financial Account",
                "account_type": "Financial Account Type",
                "bank": "Bank",
                "bank_country": "Bank country",
                "bank_name": "Bank name",
                "account_holder": "Account holder",
                "account_holder_info": "Information about the alternate account holder",
                "swift": "SWIFT/BIC",
                "account_number": "Account number",
                "reference": "Reference",
                "bank_street": "Bank street/nr.",
                "bank_zip": "Bank ZIP/city",
                "account": "Account",
                "account_confirm": "Confirm account",
                "paxum_confirm": "I confirm, that I want to receive outpayments to the Paxum account given above.",
                "exemption": "Differing account holder? Payment only after the declaration of exemption has been sent:"
            },
            "master_settings": {
                "title": "Master Settings",
                "active_title": "Show Status",
                "active": "Status",
                "chat_title": "Chat",
                "messages_title": "Messages",
                "finances_title": "Finances",
                "permissions_title": "Permissions",
                "end_user_price": "User price",
                "price_per_minute": "{price} / minute",
                "price_per_message": "{price} / message",
                "price_per_message_hint1": "New customers receive a limited number of free messages. These will not be remunerated.",
                "price_per_message_hint2": "However, customers have the option of choosing a higher price themselves (\"tip\").",
                "edit_welcome_messages": "May the show edit welcome messages?",
                "showlivepic": "Show live picture as preview picture?",
                "sendsound": "Broadcast with sound?",
                "exclusivec2c": "Only one Cam2Cam session at once?",
                "edit_freemode": "Show can offer free mode?",
                "edit_exclusivemode": "Show can switch between exclusive-chat modes?",
                "exclusive_voyeur": "Voyeurs allowed in exclusive-chat?",
                "minpreis": "Show can set prices (chat, pictures, videos)?",
                "provisionsanzeige": "May the show see its share of sales?",
                "umsatzzahlen": "Can the show see master sales?",
                "provision": "Percentage of sales (commission):",
                "edit_setcard": "Edit profile",
                "edit_bilder": "Edit galleries/videos",
                "edit_webcam": "Edit broadcast setup",
                "edit_textmakro": "Edit makros",
                "call_active": "Enable phone service",
                "view_supportmails": "Support messages"
            },
            "create_show": {
                "header": "New Show",
                "success": "Show successfully created!",
                "success_p1": "We have sent an email with login information to the email address you provided.",
                "success_p2": "Please complete the profile of the new show now.",
                "show_template": "Template",
                "select_show_template": "Use an existing show as a template:",
                "success_edit_show": "Edit show now"
            },
            "shows": {
                "commission": "Commission",
                "commission_show": "show C.",
                "lastlogin": "Login",
                "create": "Add Show",
                "tt_commission": "Percentage of sales (commission)",
                "tt_commission_show": "Commission visible in the login area of the show?",
                "tt_login": "Last login",
                "tt_avg_duration": "Average hold time",
                "tt_rating": "Average user rating",
                "tt_red": "Must be completed",
                "tt_yellow": "Should be completed"
            },
            "agb_changed": {
                "title": "TaC updated",
                "p1": "The general terms and conditions have been updated.",
                "p2": "Please accept the new <a class=\"text-dark\" style=\"text-decoration: underline\" href=\"{url}\" target=\"_blank\">TaC</a> to continue.",
                "accept": "Accept",
                "later": "Later"
            }
        },
        "profile": {
            "adminlocked": "The profile settings have been deactivated.",
            "language_adminlocked": "The language settings have been deactivated.",
            "profile": {
                "about_you": "About you",
                "slogan": "Slogan",
                "description": "Description",
                "hobbies": "Hobbies",
                "bday": "Birthday",
                "body_features": "Body features",
                "bust_size": "Bust size",
                "cupsize": "Bust size",
                "height": "Height",
                "hair_color": "Hair color",
                "haircolor": "Hair color",
                "piercing": "Piercing",
                "eye_color": "Eye color",
                "eyescolor": "Eye color",
                "body": "Body",
                "skin_color": "Skin color",
                "skincolor": "Skin color",
                "hair_length": "Hair length",
                "hairlength": "Hair length",
                "intimate_shaving": "Intimate shaving",
                "shave": "Intimate shaving",
                "zodiac": "Zodiac",
                "sexuality": "Sexuality",
                "gender": "Gender",
                "orientation": "Orientation",
                "sexualtendence": "Orientation",
                "erotic_interests": "Erotic interests",
                "sexpref": "Erotic interests",
                "add_fetish": "add fetish",
                "character_features": "Character features",
                "character": "Character",
                "add_feature": "add feature",
                "languages": "Languages",
                "add_language": "add language",
                "language_very_good": "very good",
                "language_good": "good",
                "language_some": "some",
                "location": "Location",
                "city": "City",
                "country": "Country",
                "tooltips": {
                    "x_of_y_confirmed": "{x}/{y} confirmed",
                    "x_of_y_pending": "{x}/{y} pending for confirmation",
                    "x_of_y_rejected": "{x}/{y} rejected"
                }
            },
            "account": {
                "heading": "Account settings",
                "show_name": "Show name",
                "show_login": "Show login",
                "password": "Password",
                "repeat_password": "Repeat password",
                "email": "Email",
                "send_password": "Send password via email",
                "send_password_short": "Send via email",
                "password_hidden_placeholder": "Not shown here for security reasons",
                "errors": {
                    "name_unique": "Name is already taken",
                    "login_unique": "Login already taken",
                    "referrer_valid": "Referrer ID invalid"
                }
            }
        },
        "tax": {
            "payout_suspended": "Payouts will be suspended!",
            "payout_suspended2": "The next payout will be suspended. Please complete the DAC7 interview as quickly as possible.",
            "payout_suspended3": "By April 30, 2024 at the latest.",
            "dac7_btn_init": "Start interview now",
            "dac7_btn_edit": "Edit data",
            "dac7_btn_finish": "Complete interview",
            "dac7_title": "DAC7 Tax Interview",
            "dac7_introduction": "Under EU regulations (colloquially referred to as DAC7), digital platforms are required to\n                                     provide the EU with information about the income of its users.\n                                     This affects all users with residence/company headquarters in the EU.",
            "dac7_introduction_2": "Please complete the DAC7 tax interview. This shouldn't take longer than 5 minutes. We are obliged to suspend payouts until we have all the necessary data.",
            "classification_title": "What is your tax classification?",
            "classification_hint": "If you're not sure, you should select \"Individual\"",
            "classification_individual": "Individual",
            "classification_entity": "Legal Enity / Business Entity",
            "personal_data_title": "Personal Data",
            "legal_address_type": "Address Type",
            "vat_invalid": "The VAT number could not be validated. Please make sure the VAT number matches the country of your address. Click save to check again.",
            "vat_invalid_unknown": "The VAT number cannot be validated at the moment. Try again later. Or continue and we'll take care of it.",
            "vat_waiting": "VAT ID is being checked",
            "vat_invalid2": "We could not validate your VAT ID. Please check your input!",
            "vat_hint": "The VAT identification number (if available) is required for commission billing",
            "tin_invalid": "The TIN could not be validated. Please make sure that the TIN matches the selected country. Click save to check again.",
            "vat_hint1": "If you as an individual do not have a VAT number, you can leave this field blank",
            "no_tin": "I don't have a tax identification number",
            "tin_hint": "Where do I find my TIN? (official EU website)",
            "tin_hint2": "You must provide the TIN issued by the country where your primary residence is located.\n                     Unfortunately, the absence of this information can only be accepted in exceptional cases!",
            "tin_hint3": "Unfortunately, different rules apply to what exactly has to be entered as a “TIN”, depending on the country.\n             Please ask your tax advisor or tax authority if you are not sure.",
            "save_hint": "You can save your data at any time. Once you've completed everything, continue to the \"Complete\" section. Only then will your entries be checked.",
            "complete_title": "Complete",
            "complete_check": "I hereby affirm that all information is complete and truthful.",
            "complete_btn": "Complete and submit for review",
            "status_rejected": "rejected",
            "status_init": "please complete",
            "status_waiting": "reviewing",
            "status_confirmed": "review successful",
            "confirm_account_holder": "I hereby confirm that I am the account holder.",
            "account_holder_info_hint": "Please provide <u>all</u> known information about the account holder.\n             <br/><br/>If information is missing or incomplete\n             no further payouts will be made!</b>",
            "status_waiting_hint_p1": "Your entries will now be checked.",
            "status_waiting_hint_p2": "Once the review is complete, you can adjust your information again if necessary.",
            "status_rejected_hint_p1": "Your entries could not be confirmed.",
            "status_rejected_hint_p2": "Please note the information we have sent you about this. Revise your entries and complete the form again.",
            "status_data_changed_hint_p1": "Please check your details.",
            "status_data_changed_hint_p2": "You have changed your master data or deleted documents. Please check your entries and complete the form again.",
            "status_confirmed_hint_p1": "Your entries have been successfully confirmed.",
            "status_confirmed_hint_p2": "If you change your details now, they will need to be checked again!",
            "clearing_link": "You'll find settings for your financial account under <a href=\"{url}\">{txt}</a>.",
            "legal_address_types_OECD301": "residential or business",
            "legal_address_types_OECD302": "residential",
            "legal_address_types_OECD303": "business",
            "legal_address_types_OECD304": "registered office",
            "legal_address_types_OECD305": "unspecified",
            "in_types": {
                "BRN": "Business Registration Number (BRN)",
                "IIN": "Individual Identification Number (IIN)",
                "LEI": "Legal Entity Identifier (LEI)",
                "EIN": "Entity Identification Number (EIN)",
                "Other": "Other"
            }
        },
        "broadcast": {
            "download_title": "Latest Sender Software",
            "download_win": "Download v{version} for Windows",
            "download_win_title": "Download latest Windows Software",
            "download_mac": "Download v{version} for Mac",
            "download_mac_title": "Download latest Mac Software",
            "open_in_browser": "Broadcast now!",
            "open_in_browser_title": "Broadcast Without Download",
            "exclusive_mode": "Exklusive chat mode",
            "exclusive_mode_no": "No",
            "exclusive_mode_separee": "Separee",
            "exclusive_mode_single": "Single User Mode",
            "price_factor": "Price factor",
            "register_phone_service": "Register for the telephopne service now!",
            "cannot_go_online": "You cannot send at the moment",
            "reasons": {
                "statusid": "The show must be activated by support",
                "agechecked": "Age verification has not yet been completed",
                "disabled": "The show has been deactivated in the master account",
                "previewok": "Preview pictures still have to be uploaded / activated",
                "galleryok": "Free gallery images still need to be uploaded / activated",
                "disableduntil": "Temporarily locked until: {date}",
                "documents": "Documents are required to complete your profile"
            },
            "chrome": {
                "link": "Please use Google Chrome",
                "tooltip": "You can also use other browsers (Firefox, Opera, ...). For the best results, you should use Chrome."
            },
            "test_chat": {
                "btn": "Test Chat",
                "tooltip_offline": "Please go online, to activate the test chat"
            }
        },
        "navigation": {
            "media": "Media",
            "galleries": "Galleries",
            "videos": "Videos",
            "profile": "Profile",
            "profile_data": "Data",
            "profile_clearing": "Clearing",
            "profile_documents": "Documents",
            "account": "Account",
            "verification": "Verification",
            "statistics": "Statistics",
            "messages": "Messages",
            "contacts": "Contacts",
            "support": "Support",
            "broadcast": "Broadcast",
            "settings": "Settings",
            "macros": "Macros",
            "phoneservice": "Phone Service",
            "mastersettings": "Settings",
            "messagessettings": "Settings",
            "getmore": "Get More",
            "bookings": "Accounting",
            "conditions": "Conditions",
            "shows": "Shows",
            "back_to_master": "Back To Master Account",
            "back_to_master_dd": "Master Account",
            "logout": "Sign-out",
            "lang": "Language",
            "master_login": "Master Login",
            "master_chat": "Chat",
            "faq": "FAQ",
            "documents": "Documents",
            "toy-control": "Lovense Toys"
        },
        "messages": {
            "support_messages": "Support Messages",
            "support_messages_shows": "My Shows's Support Messages",
            "support_inbox": "My Inbox",
            "support_inbox_shows": "Shows Inbox",
            "user_messages": "Conversations",
            "settings": "Messages Settings",
            "all_shows": "All Shows",
            "last_chat": "last chat",
            "coins_spent": "coins spent",
            "total_chattime": "total chat time",
            "last_chats": "Last chats",
            "stats": "Stats",
            "time_in_chat": "time in chat",
            "minutes_in_chat": "minutes in chat",
            "messages_written": "messages written",
            "videos_bought": "videos bought",
            "galleries_bought": "galleries bought",
            "coins_spent_chat": "coins spent in chat",
            "coins_spent_messages": "coins spent on messages",
            "coins_spent_galleries": "coins spent on galleries",
            "coins_spent_videos": "coins spent on videos",
            "coins_spent_you": "total coins spent on you",
            "contacts": "Contacts",
            "contact_established": "contact established",
            "no_messages_yet": "no messages send yet",
            "add_favorite": "add favorite",
            "remove_favorite": "remove favorite",
            "add_hidden": "hide for this session",
            "remove_hidden": "show again",
            "blocked_shows_only": "Please log in as show to block users",
            "add_blocked": "block user",
            "remove_blocked": "unblock user",
            "send_message": "send message",
            "unblock_first": "cannot send messages to hidden or blocked contacts",
            "premium": "premium",
            "you": "you",
            "you_via_master": "you (via master)",
            "premium_message_success": "{x} coins CLAIMED!",
            "premium_message_available": "Premium: {x} coins",
            "premium_message_missed": "{x} coins MISSED!",
            "premium_tooltip_success": "You successfully claimed this reward",
            "premium_tooltip_default": "Reply to messages in 24 hours to claim the bounty",
            "premium_tooltip_until": "Reply until {time} to claim the bounty",
            "mark_as_read": "Mark as read",
            "send": "Send",
            "select_to_answer": "Please select a message to answer to",
            "no_conversations1": "You dont have any conversations yet",
            "no_conversations2": "Click on {action} to choose a conversation partner you want to chat with.",
            "choose_conversation": "Choose a conversation partner you want to chat with.",
            "no_messages": "No messages yet.",
            "start_conversation_here": "Start your conversation here",
            "no_contacts_found": "No contacts found",
            "no_contacts_yet": "You don't have any contacts yet. After users have been in your chat, you can find them here.",
            "delete_conversation": "Really remove the conversation with: nickname?",
            "member_deleted": "This contact cannot receive any messages at the moment.",
            "messages_error": "Failed to load messages. Try again: ",
            "filter": "Filter",
            "filters": {
                "chatted_once": "has chatted at least once",
                "chatted_10": "has chatted at least 10 minutes",
                "chatted_30": "has chatted at least 30 minutes",
                "bought_video": "has bought a video",
                "bought_no_video": "has not bought a video",
                "bought_gallery": "has bought a gallery",
                "bought_no_gallery": "has not bought a gallery",
                "hidden": "hidden by you",
                "blocked": "blocked by you",
                "favorite": "is favorite"
            },
            "welcome_messages": {
                "headline": "Automatic Messages",
                "title1": "Opener Message",
                "subtitle1": "Send automatic messages to users you haven't been in contact with yet. Expand your contact list and get more users to write to you or visit your chat."
            }
        },
        "statistics": {
            "title": "Statistics",
            "current_turnover": "This month's turnover",
            "current_online_time": "This month's holding time",
            "average_rating": "Average. rating",
            "average_holding_time": "Average holding time",
            "sales_detail": "Sales Setails From {date}",
            "online_detail": "Online Times From {date}",
            "sales": "Sales from {startdate} to {stopdate}",
            "online": "Online Times from {startdate} to {stopdate}",
            "no-data": "No data available",
            "live_data_hint": "<span class=\"text-warning\">Marked values</span> are not archived yet and are subject to change",
            "total": "Total",
            "date": "Date",
            "sessions": "Sessions",
            "duration": "Duration",
            "minutes": "Minutes",
            "online_minutes": "Online Minutes",
            "chat_minutes": "Chat Minutes",
            "hold_time": "Hold Time",
            "turnover": "Turnover",
            "turnover_master": "Turnover Master",
            "turnover_show": "Turnover Show",
            "start": "Start",
            "end": "End",
            "program": "Program",
            "showname": "Showname",
            "user": "User",
            "type": "Type",
            "section-table": "Details",
            "section-turnover": "Turnover",
            "section-onlinetimes": "Online Tiems",
            "section-onlinetimes-distribution": "Online Times Distribution",
            "section-chatsession-distribution": "Chatsession Distribution",
            "timezone-hint": "All dates in {tz}",
            "session_type_All": "All",
            "session_type_Show": "Show",
            "session_type_Bilder": "Pictures",
            "session_type_Videos": "Videos",
            "session_type_Voyeurchat": "Voyeur",
            "session_type_Separee": "Separee",
            "session_type_ruf777": "ruf777",
            "session_type_Message": "Message",
            "session_type_Tip": "Tip",
            "session_type_ToyControl": "ToyControl",
            "session_type_Master-Chat": "TestChat"
        }
    }
}
